import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  ListItem,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  TextField,
  Typography
} from '@material-ui/core';

import CircularProgress from '@material-ui/core/CircularProgress';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import AddIcon from '@material-ui/icons/Add';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import CloseIcon from '@material-ui/icons/Close';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import ReportIcon from '@material-ui/icons/Report'; // Garanti Dışı için
import RotateRightIcon from '@material-ui/icons/RotateRight';
import SendIcon from '@material-ui/icons/Send';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import WarningIcon from '@material-ui/icons/Warning';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { connect } from 'react-redux';
import logger from 'src/utils/logger';
import { useHistory } from 'react-router';
import 'src/assets/css/alert.css';
import Odero from 'src/assets/images/odero.png';
import OlizIcon from 'src/assets/images/oliz.png';
import Alert from 'src/components/Alert';
import SonlandirOzet from 'src/components/FinalProcessSpecial';
import KocailemVerification from 'src/components/KocailemVerification';
import MaterialDebitVerification from 'src/components/MaterialDebitVerification';
import MEGPopup from 'src/components/SatisfactionAdditionalWarranty';
import UDGPopup from 'src/components/UDGPopup';
import axios from 'src/utils/axios';
import {
  getKoordinat,
  GetLocation,
  getUser,
  safeRequestParam
} from 'src/utils/Common';
import {
  checkHomewhiz,
  checkValidBarkod,
  loadBaslandiJob,
  removeBaslandiJob,
  saveBaslandiJob
} from 'src/utils/storage/StartWorkOrder';
import { uploadFotograf } from 'src/utils/storage/StrPhoto';
import QrBarkodPopup from '../../components/BarcodePopup';
import { text } from '../../modules/languages/index';
import { setTask } from '../../store/actions/taskActions';

const useStyles = makeStyles(theme => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  searchInputCC: {
    flexGrow: 1
  },
  searchCC: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconCC: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  submitMaterialImage: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  techWarnMessage: {
    color: 'red'
  },
  dialog: {
    zIndex: '1301 !important' // Material-UI'nın varsayılan z-index değeri 1300'dür.
  },
  confirmOverlay: {
    zIndex: 9999 + ' !important'
  }
}));

function Sonlandir({
  className,
  FisNo,
  readonly,
  setReadonly,
  InsuranceVisible,
  tasks,
  setTask
}) {
  const SessionUser = getUser();
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [Uyari1, setUyari1] = React.useState('');
  const [Uyari2, setUyari2] = React.useState('');
  const classes = useStyles();
  const [LoadingControl, setLoadingControl] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [islemYeri, setIslemYeri] = useState('1');
  const [tahsilatTipi, setTahsilatTipi] = useState(0);
  const [tahsilatGoster, setTahsilatGoster] = useState(false);
  const [sonDurum, setSonDurum] = useState('4');
  const [TokenPayPopupOpen, setTokenPayPopupOpen] = useState(false);
  const [confirmOpenIcUniteKlima, setConfirmOpenIcUniteKlima] = useState(false);
  const [sonDurumAciklama, setSonDurumAciklama] = useState(
    'Kapat (Hizmet Tamamlandı)'
  );
  const [FilterPaper, setFilterPaper] = useState('');
  const [tutar, setTutar] = useState(0);
  const manuelTutarDegisikligiRef = useRef(false);
  const [tahsil_edilmis_tutar, settahsil_edilmis_tutar] = useState(0);
  const [openLegal, setOpenLegal] = useState(false);
  const [kocailemOpen, setKocailemOpen] = useState(false);
  const [kocailemGoster, setKocailemGoster] = useState(false);
  const [OpenUDGNedenPopUp, setOpenUDGNedenPopUp] = React.useState(false);
  const [MEGOpenPopUp, setMEGOpenPopUp] = React.useState(false);
  const [debitOpen, setDebitOpen] = useState(false);
  const [openQrBarkod, setOpenQrBarkod] = useState(false);
  const [OlizGoster, setOlizGoster] = useState(false);
  const [ExtraBilgiPopup, setExtraBilgiPopup] = useState(false);
  const [CevrimSayisi, setCevrimSayisi] = useState(0);
  const [TahsilatTutar, setTahsilatTutar] = useState(0);
  const [TahsilatTutarKalan, setTahsilatTutarKalan] = useState(0);
  const [urunTercihi, setUrunTercihi] = useState(false);
  const [benchmarkBrandData, setBenchmarkBrandData] = useState([]);
  const [benchmarkBrandID, setBenchMarkBrandID] = useState(0);
  const [brandName, setBrandName] = useState(
    Array(benchmarkBrandData.length).fill([])
  );
  const [urunTercihSoru, seUrunTercihSoru] = useState(false);
  const [DATAAI_TIP, setDATAAI_TIP] = useState('');
  const [DATAAI_Popup, setDATAAI_Popup] = useState(false);
  const [DATAAI_PopupText, setDATAAI_PopupText] = useState('');
  const [depositProductPopUp, setDepositProductPopUp] = useState(false);
  const [personalPrimPopUp, setPersonalPrimPopUp] = useState(false);
  const [openStackingKitPopUp, setOpenStackingKitPopUp] = useState(false);
  const [stackingKitData, setStackingKitData] = useState([]);
  const [personelEkleme, setPersonalEkleme] = useState(false);
  const [personalCalisanlari, setPersonalCalisanlari] = useState([]);
  const [personalLoading, setPersonalLoading] = useState(false);
  const [lojistikPersonelKontrol, setLojistikPersonelKontrol] = useState(0);
  const [hasZimmet, setHasZimmet] = useState(0);
  const [selectedLojisticEmployees, setSelectedLojisticEmployees] = useState(
    []
  );
  const [state, setState] = useState({
    EMANET_URUN: false,
    URUN_KULLANILABILIR: false
  });
  const { EMANET_URUN, URUN_KULLANILABILIR } = state;
  const [
    selectedNewRafliKitMetarialCode,
    setSelectedNewRafliKitMetarialCode
  ] = React.useState(null);
  const [insuranceSalesPopup, setInsuranceSalesPopup] = useState(false);
  const history = useHistory();
  const [SonucNotu, setSonucNotu] = useState('');
  const [ProjeKodu, setProjeKodu] = useState('');
  const [
    selectedLojisticEmployeesFullNames,
    setSelectedLojisticEmployeesFullNames
  ] = useState('');
  const [lojistikPersonelYok, setLojistikPersonelYok] = useState(false);

  let SonlandirData = readonly
    ? Array.isArray(tasks?.tasks)
      ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo))
      : []
    : Array.isArray(loadBaslandiJob())
    ? loadBaslandiJob()
    : [];

  const handleCardClick = code => {
    if (selectedNewRafliKitMetarialCode === code) {
      setSelectedNewRafliKitMetarialCode(null);
    } else {
      setSelectedNewRafliKitMetarialCode(code);
    }
  };
  const handleCloseopenLegal = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenLegal(false);
  };

  const handleKocailemOpen = () => {
    // SonlandirData?.[0] kullanarak güvenli hale getiriyoruz
    if (parseInt(SonlandirData?.[0]?.KOCAILEM) === 1) {
      setUyari1('Bu fiş daha önce KoçAilem doğrulaması yapılmış.');
      setOpen(true);
      return;
    }
    setKocailemOpen(true);
  };

  const applyKocAilem = useCallback(() => {
    let jobs = loadBaslandiJob();
    if (!jobs || jobs.length === 0) return; // Eğer iş yoksa fonksiyondan çık

    let job = jobs[0];

    let user = getUser();
    let discountProgram = user.Discounts.filter(f => parseInt(f.TIP) === 1);
    let totalPrice = (job.ISCILIK_TOPLAM || 0) + (job.MALZEME_TOPLAM || 0);
    if (discountProgram.length === 0 || totalPrice <= 0) {
      return;
    }
    let dp = discountProgram[0];
    var newPrice = 0;
    if (job.ISCILIK_TOPLAM > 0) {
      newPrice += job.ISCILIK_TOPLAM * (1 - dp.ISCILIK_ORANI);
    }
    if (job.MALZEME_TOPLAM > 0) {
      newPrice += job.MALZEME_TOPLAM * (1 - dp.MALZEME_ORANI);
    }
    newPrice = parseFloat(newPrice.toFixed(2));
    job = {
      ...job,
      INDIRIMLI_TUTAR_KDVLI: newPrice
    };
    saveBaslandiJob(job);
    setTutar(newPrice);
    alertMessage(
      'success',
      `KoçAilem programı kapsamında ${totalPrice.toFixed(
        2
      )}₺ işlem üzerinden ${(totalPrice - newPrice).toFixed(
        2
      )}₺ indirim uygulandı.`
    );
  }, []);

  const handleSubmit = event => {
    event.preventDefault();
  };

  useEffect(() => {
    let SonucNotuDeger = '';
    let ProjeKoduDeger = '';
    let lojistikPersonelYokDeger = '';
    let lojistikPersonelFullNameDeger = '';

    if (!Array.isArray(SonlandirData) || SonlandirData.length === 0) {
      SonucNotuDeger = '';
      ProjeKoduDeger = '';
      lojistikPersonelFullNameDeger = '';
      lojistikPersonelYokDeger = '';
    } else {
      SonucNotuDeger = SonlandirData[0]?.SONUC_NOTU || '';
      ProjeKoduDeger = SonlandirData[0]?.PROJE_KODU || '';
      lojistikPersonelFullNameDeger =
        Array.isArray(SonlandirData[0]?.LOJISTIK_PERSONEL_AD_SOYAD) &&
        SonlandirData[0]?.LOJISTIK_PERSONEL_AD_SOYAD.length > 0
          ? SonlandirData[0]?.LOJISTIK_PERSONEL_AD_SOYAD.map(
              person => person.AD_SOYAD
            ).join(',')
          : '';
      let lojistikPersonelYokDegerKontrol = (
        SonlandirData[0]?.LOJISTIK_PERSONEL_AD_SOYAD || []
      ).filter(i => i.ID === 0);
      lojistikPersonelYokDeger =
        lojistikPersonelYokDegerKontrol.length > 0 ? true : false;
    }
    setSonucNotu(SonucNotuDeger);
    setProjeKodu(ProjeKoduDeger);
    setSelectedLojisticEmployeesFullNames(lojistikPersonelFullNameDeger);
    setLojistikPersonelYok(lojistikPersonelYokDeger);
  }, [SonlandirData]);

  let iscilik_toplam = 0;
  let malzeme_toplam = 0;
  let yol_odeme_toplam = 0;
  if (Array.isArray(SonlandirData) && SonlandirData.length > 0) {
    iscilik_toplam = SonlandirData[0]?.ISCILIK_TOPLAM || 0;
    malzeme_toplam = SonlandirData[0]?.MALZEME_TOPLAM || 0;
    yol_odeme_toplam = SonlandirData[0]?.YOLODEME_TUTAR || 0;
  }

  const handlePersonalEkle = () => {
    setPersonalPrimPopUp(true);
    setPersonalEkleme(true);

    let birimKodu = null;
    let kaynak = '';
    let LojistikPersonelAdiSoyadi = '';

    // 1. Önce SonlandirData'ya bak (readonly/tamamlanmış fişler için)
    if (
      Array.isArray(SonlandirData) &&
      SonlandirData.length > 0 &&
      SonlandirData[0]?.BIRIM_KODU
    ) {
      birimKodu = SonlandirData[0].BIRIM_KODU;
      LojistikPersonelAdiSoyadi =
        SonlandirData[0]?.LOJISTIK_PERSONEL_AD_SOYAD || [];
      kaynak = 'SonlandirData';
      console.log('SonlandirData BIRIM_KODU:', SonlandirData[0]?.BIRIM_KODU);
    }
    // 2. Yoksa job (loadBaslandiJob)'a bak
    else {
      const jobs = loadBaslandiJob();
      if (Array.isArray(jobs) && jobs.length > 0 && jobs[0]?.BIRIM_KODU) {
        birimKodu = jobs[0].BIRIM_KODU;
        LojistikPersonelAdiSoyadi = jobs[0]?.LOJISTIK_PERSONEL_AD_SOYAD || [];
        kaynak = 'Job';
        console.log('Job BIRIM_KODU:', jobs[0]?.BIRIM_KODU);
      }
    }

    // BIRIM_KODU kontrolü
    if (!birimKodu) {
      logger.error(`BIRIM_KODU bulunamadı! Kaynak: ${kaynak || 'YOK'}`);
      setUyariTip('error');
      setUyariAciklama('Birim kodu bulunamadı! Lütfen tekrar deneyin.');
      setUyari(true);
      setPersonalCalisanlari([]);
      return;
    }

    setSelectedLojisticEmployees(
      LojistikPersonelAdiSoyadi ? LojistikPersonelAdiSoyadi : []
    );

    setPersonalLoading(true);
    logger.info(
      `Lojistik personel listesi çekiliyor. Kaynak: ${kaynak}, BIRIM_KODU: ${birimKodu}`
    );

    axios
      .get(`GetLojistikPersonel/${birimKodu}`)
      .then(response => {
        logger.info('API Response:', response.data);
        // Her durumda state'i güncelle (boş array olsa bile)
        if (Array.isArray(response.data)) {
          setPersonalCalisanlari(response.data);
          if (response.data.length === 0) {
            logger.warn(
              `BIRIM_KODU: ${birimKodu} için lojistik personel bulunamadı`
            );
            setUyariTip('warning');
            setUyariAciklama(
              'Bu birim için kayıtlı lojistik personel bulunamadı.'
            );
            setUyari(true);
          } else {
            logger.info(`${response.data.length} lojistik personel bulundu`);
          }
        } else {
          logger.error('API beklenmeyen formatta veri döndü:', response.data);
          setPersonalCalisanlari([]);
          setUyariTip('error');
          setUyariAciklama('Lojistik personel listesi alınamadı!');
          setUyari(true);
        }
      })
      .catch(error => {
        logger.error(
          `Lojistik personel listesi hatası (BIRIM_KODU: ${birimKodu}):`,
          error.message,
          error.response?.data
        );
        setPersonalCalisanlari([]);
        setUyariTip('error');
        setUyariAciklama(
          `Lojistik personel listesi alınamadı: ${error.message}`
        );
        setUyari(true);
      })
      .finally(() => {
        setPersonalLoading(false);
      });
  };
  const handleCheckboxChange = event => {
    const checked = event.target.checked;
    setLojistikPersonelYok(checked);

    axios
      .get(`/SetLojistikPersonelEkleme/${FisNo}/${0}`)
      .then(response => {
        if (response.data) {
          const jobs = loadBaslandiJob();
          if (!Array.isArray(jobs) || jobs.length === 0) {
            logger.error('Job bulunamadı');
            return;
          }
          let job = jobs[0];
          job = {
            ...job,
            LOJISTIK_PERSONEL_AD_SOYAD: [
              { ID: 0, AD_SOYAD: 'Lojistik Personeli Yok' }
            ]
          };
          saveBaslandiJob(job);
          setSelectedLojisticEmployeesFullNames('Lojistik Personeli Yok');
          setLojistikPersonelKontrol(2);
        }
      })
      .catch(error => {
        logger.error(
          'Lojistik personel yok işareti kaydedilemedi:',
          error.message
        );
        setUyariTip('error');
        setUyariAciklama('Lojistik personel bilgisi kaydedilemedi!');
        setUyari(true);
        // Hata durumunda checkbox'ı eski haline getir
        setLojistikPersonelYok(!checked);
      });
  };
  const handleLojistikPersonelIdChange = (event, value) => {
    if (!value) {
      setSelectedLojisticEmployees([]);
      return;
    }

    if (value.length <= 4) {
      const uniqueValues = value.filter(
        (v, index, self) => index === self.findIndex(t => t.ID === v.ID)
      );
      setSelectedLojisticEmployees(uniqueValues);
    }
  };
  const handleLojistikPersonelKaydet = () => {
    if (selectedLojisticEmployees.length > 4) {
      setUyari1('4 kişiden fazla ekleyemezsiniz!');
      setOpen(true);
      return;
    }
    let PersonelId =
      selectedLojisticEmployees.length > 0
        ? selectedLojisticEmployees
            .map(id => id.ID)
            .filter(id => id != null)
            .join(',')
        : null;

    axios
      .get(`/SetLojistikPersonelEkleme/${FisNo}/${PersonelId}`)
      .then(response => {
        if (response.data) {
          const jobs = loadBaslandiJob();
          if (!Array.isArray(jobs) || jobs.length === 0) {
            return; // ya da kontrollü hata
          }
          let job = jobs[0];
          job = {
            ...job,
            LOJISTIK_PERSONEL_AD_SOYAD: [
              ...(Array.isArray(job.LOJISTIK_PERSONEL_AD_SOYAD)
                ? job.LOJISTIK_PERSONEL_AD_SOYAD.filter(existingPerson =>
                    selectedLojisticEmployees.some(
                      newPerson => newPerson.ID === existingPerson.ID
                    )
                  )
                : []),
              ...selectedLojisticEmployees
                .filter(
                  newPerson =>
                    !job.LOJISTIK_PERSONEL_AD_SOYAD.some(
                      existingPerson => existingPerson.ID === newPerson.ID
                    )
                )
                .map(person => ({
                  ID: person.ID,

                  AD_SOYAD: person.AD_SOYAD
                }))
            ]
          };
          setSelectedLojisticEmployeesFullNames(
            Array.isArray(selectedLojisticEmployees) &&
              selectedLojisticEmployees.length > 0
              ? selectedLojisticEmployees
                  .map(person => person.AD_SOYAD)
                  .join(',')
              : ''
          );
          saveBaslandiJob(job);
          setLojistikPersonelKontrol(2);
        }
        setPersonalPrimPopUp(false);
      });
  };
  const handleGetLogisticEmployee = useCallback(() => {
    // Hizmet kodlarını al - Öncelik sırası: SonlandirData -> MerkezeGonderilecekData -> job
    let hizmetler = null;
    let kaynak = '';

    // 1. Önce SonlandirData'ya bak
    if (
      Array.isArray(SonlandirData) &&
      SonlandirData.length > 0 &&
      Array.isArray(SonlandirData[0]?.HIZMETLER)
    ) {
      hizmetler = SonlandirData[0].HIZMETLER;
      kaynak = 'SonlandirData';
    }
    // 2. Yoksa job (loadBaslandiJob)'a bak
    else {
      const jobs = loadBaslandiJob();
      if (
        Array.isArray(jobs) &&
        jobs.length > 0 &&
        Array.isArray(jobs[0]?.HIZMETLER)
      ) {
        hizmetler = jobs[0].HIZMETLER;
        kaynak = 'Job';
      }
    }

    // Hizmet kodlarını virgülle ayırarak birleştir
    let hizmetKodlari = '';
    if (hizmetler) {
      hizmetKodlari = hizmetler
        .map(h => h.HIZMET_KODU || h.KUL_HIZMET_KODU)
        .filter(kod => kod != null)
        .join(',');
    }

    logger.info(
      `Lojistik personel kontrolü - FisNo: ${FisNo}, Kaynak: ${kaynak ||
        'YOK'}, HizmetKodları: ${hizmetKodlari || 'YOK'}`
    );

    // Hizmet kodları boş ise API'ye istek atma
    if (!hizmetKodlari || hizmetKodlari.trim() === '') {
      logger.warn(
        'Hizmet kodları bulunamadı, lojistik personel kontrolü yapılmadı'
      );
      setLojistikPersonelKontrol(0);
      return;
    }

    axios
      .get(`/SetLojistikPersonelEklemeKontrol/${FisNo}/${hizmetKodlari}`)
      .then(response => {
        setLojistikPersonelKontrol(response.data);
      })
      .catch(error => {
        logger.error('Hata detayı:', error.message);
      });
  }, [FisNo, SonlandirData]);

  const handleMalzemeSecimiPopUp = () => {
    let job = loadBaslandiJob()?.[0];
    if (!job) return;
    setOpenStackingKitPopUp(true);
    axios
      .get(
        `/GetDinamikGrupRafliMalzemeList/${job.BIRIM_KODU}/${SessionUser.TechnicianId}`
      )
      .then(response => {
        const data = Array.isArray(response.data) ? response.data : [];
        setStackingKitData(data);
        const zimmet = data.some(item => item.TEKNISYEN_ZIMMET_ADET > 0);
        setHasZimmet(zimmet);
      })
      .catch(error => {
        setStackingKitData([]);
        setHasZimmet(false);
        logger.error('Hata detayı:', error.message);
      });
  };

  const handleRafliKitMalzemeIcinFisOlustur = () => {
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    if (!job || !selectedNewRafliKitMetarialCode) return;

    const eskiRafliMalzemeler = Array.isArray(job?.MALZEMELER)
      ? (job.MALZEMELER || []).filter(
          item =>
            item.ACIKLAMA?.includes('Sınıf:Bağlantı Kiti Malzemeleri') ||
            item.SINIF_KODU === 6018
        )
      : [];

    if (!eskiRafliMalzemeler?.length) return;

    const SecilenEskiRafliMalzemeKodu = eskiRafliMalzemeler[0]?.MALZEME_KODU;

    axios
      .get(
        `/SetArtemisStackingKitFisOlustur/${job.FisNo}/${job.MusteriNo}/${selectedNewRafliKitMetarialCode}/${SecilenEskiRafliMalzemeKodu}`
      )
      .then(response => {
        if (parseInt(response.data.ErrorCode) === 0) {
          const kalanMalzemeler = job.MALZEMELER.filter(
            item =>
              !(
                item.ACIKLAMA?.includes('Sınıf:Bağlantı Kiti Malzemeleri') ||
                item.SINIF_KODU === 6018
              )
          );
          job = {
            ...job,
            MALZEMELER: kalanMalzemeler
          };
          saveBaslandiJob(job);
          setUyariTip('success');
          setUyari(true);
          setUyariAciklama('Raflı Malzeme için Fiş başarılı şekilde oluştu.');
          setSelectedNewRafliKitMetarialCode(null);
          handleMerkezeGonder();
          setOpenStackingKitPopUp(false);
        }
        if (parseInt(response.data.ErrorCode) === 1000) {
          setUyariTip('error');
          setUyari(true);
          setUyariAciklama(
            'Daha önce bu fiş üzerinden raflı stacking fişi oluşturulmuştur!!!'
          );
          setSelectedNewRafliKitMetarialCode(null);
          handleMerkezeGonder();
          setOpenStackingKitPopUp(false);
        } else {
          setUyariTip('error');
          setUyari(true);
          setUyariAciklama(
            'Bir hata oluştu.Raflı stacking fişi oluşturulamadı!!!'
          );
          setSelectedNewRafliKitMetarialCode(null);
          handleMerkezeGonder();
          setOpenStackingKitPopUp(false);
        }
      })
      .catch(error => {
        logger.error('Fiş oluşturma hatası:', error);
      });
  };

  const anketKontrol = async () => {
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return 0;
    }
    let job = jobs[0];
    if (job.FARKLI_SMS === true || job.FARKLI_SMS === 1) {
      return 0;
    }
    setLoadingControl(true);
    const res = await axios
      .get(
        `GetArtemisAnketV2/${job.BasvuruNo}/${job.BIRIM_KODU}/${
          job.DURUM_KODU
        }/${safeRequestParam(job.KUL_MODEL_KODU) || 'S'}/${safeRequestParam(
          job.ALINAN_SMS_KOD
        ) || 'S'}/0`
      )
      .then(response => {
        return response?.data?.length === 0
          ? 0
          : response?.data?.elements?.length > 0
          ? parseInt(response?.data?.elements?.[0]?.name)
          : 0;
      });
    return res;
  };

  const ankastreAnketKontrol = async () => {
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return 0; // ya da kontrollü hata
    }
    let job = jobs[0];

    setLoadingControl(true);
    const res = await axios
      .get(`CheckExistsFileOrSurvey/${job.FisNo}/2`)
      .then(response => {
        return response.data.length === 0 ? 0 : response.data;
      });
    return res;
  };

  const ankastreUrunKontrol = async () => {
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return 0; // ya da kontrollü hata
    }
    let job = jobs[0];

    setLoadingControl(true);
    const res = await axios
      .get('/CheckExistsFileOrSurvey/' + job.FisNo + '/3')
      .then(res => {
        return res.data;
      });
    return res;
  };

  const handleAnkastreKontrolDialog = () => {
    setOpen2(false);
    history.push(`/WorkOrder/${FisNo}/Hizmet`);
    setLoadingControl(false);
    return;
  };

  const onboardKontrol = async () => {
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return 0; // ya da kontrollü hata
    }
    let job = jobs[0];
    let hizmet456 = (job.HIZMETLER || []).filter(
      h => h.KUL_HIZMET_KODU === '456' || h.KUL_HIZMET_KODU === '458'
    );
    let durum = parseInt(job.DURUM_KODU);
    if (parseInt(job.UST_MODEL_KODU || 0) === 18603) {
      return 0;
    }
    if (hizmet456.length === 0 || durum === 4) {
      return 0;
    }
    try {
      var today = new Date();
      if (isNaN(today.getTime())) {
        logger.warn('Geçersiz tarih oluşturuldu');
        return 0;
      }
      var bit = today.toISOString().slice(0, 10);
      today.setDate(today.getDate() - 2);
      if (isNaN(today.getTime())) {
        logger.warn('Tarih hesaplama sonrası geçersiz değer');
        return 0;
      }
      var bas = today.toISOString().slice(0, 10);
      const res = await axios
        .get(`GetOnboardInfo/${job.BARKOD}/${bas}/${bit}`)
        .then(response => {
          if (response.data?.data?.deviceOnboarded) return 0;
          else return 1;
        });
      return res;
    } catch (error) {
      logger.warn('Tarih işleme hatası:', error.message);
      return 0;
    }
  };

  const RafliKitÜrünDinamikGrupKontrol = useCallback(() => {
    if (readonly) return;
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    if (!job) {
      logger.warn('Job bulunamadı');
      return;
    }
    const userModelCode = (job?.KUL_MODEL_KODU || '0').toString();
    const servisCode = job?.BIRIM_KODU || '0';
    axios
      .get(
        `/GetRafliKitUrunDinamikGrupKontrol/${userModelCode ||
          '0'}/${servisCode || '0'}`
      )
      .then(res => {
        if (res.data === 1) {
          job = {
            ...job,
            RaflıKitDinamikModelKoduKontrol: 1
          };
        } else {
          job = {
            ...job,
            RaflıKitDinamikModelKoduKontrol: 0
          };
        }
        saveBaslandiJob(job);
      });
  }, [readonly]);

  useEffect(() => {
    GetLocation();
    if (!Array.isArray(SonlandirData) || SonlandirData.length === 0) {
      return;
    }
    setIslemYeri(SonlandirData[0]?.ISLEM_YERI || '1');
    setOlizGoster(true);
    // Garanti Dışı || Ek Garanti Satışı || Tamamlayıcı Ürün
    if (
      parseInt(SonlandirData[0]?.GARANTI_TIPI || 0) === 1 ||
      (SonlandirData[0]?.HIZMETLER || []).filter(
        h =>
          parseInt(h.TIP_KODU || 0) === 7 ||
          parseInt(h.HIZMET_KODU || 0) === 1685
      ).length > 0
    ) {
      setTahsilatGoster(true);
      setTahsilatTipi(SonlandirData[0]?.TAHSILAT_TIPI || 0);
    } else {
      setTahsilatGoster(false);
      setTahsilatTipi(0);
    }
    setSonDurum(SonlandirData[0]?.SON_DURUM || '4');
    setSonucNotu(SonlandirData[0]?.SONUC_NOTU || '');
    setSelectedLojisticEmployeesFullNames(
      Array.isArray(SonlandirData[0]?.LOJISTIK_PERSONEL_AD_SOYAD) &&
        SonlandirData[0]?.LOJISTIK_PERSONEL_AD_SOYAD.length > 0
        ? SonlandirData[0]?.LOJISTIK_PERSONEL_AD_SOYAD.map(
            person => person.AD_SOYAD
          ).join(',')
        : ''
    );

    if (
      (malzeme_toplam + iscilik_toplam + yol_odeme_toplam).toFixed(2) !==
        (SonlandirData[0]?.TOPLAM_FIYAT || 0).toFixed(2) ||
      (SonlandirData[0]?.INDIRIMLI_TUTAR_KDVLI || 0) >
        malzeme_toplam + iscilik_toplam + yol_odeme_toplam
    ) {
      if (!manuelTutarDegisikligiRef.current) {
        setTutar(malzeme_toplam + iscilik_toplam + yol_odeme_toplam);
      }
      const loadedJobs = readonly ? null : loadBaslandiJob();
      let job = readonly
        ? Array.isArray(tasks?.tasks)
          ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo))?.[0]
          : null
        : Array.isArray(loadedJobs) && loadedJobs.length > 0
        ? loadedJobs[0]
        : null;

      if (!job) return;

      if (!readonly && !manuelTutarDegisikligiRef.current) {
        job = {
          ...job,
          INDIRIMLI_TUTAR_KDVLI:
            malzeme_toplam + iscilik_toplam + yol_odeme_toplam
        };
        saveBaslandiJob(job);
      }
    } else {
      if (!manuelTutarDegisikligiRef.current) {
        setTutar(SonlandirData[0]?.INDIRIMLI_TUTAR_KDVLI || 0);
      }
    }

    settahsil_edilmis_tutar(SonlandirData[0]?.TAHSIL_EDILMIS_TUTAR || 0);
    setProjeKodu(SonlandirData[0]?.PROJE_KODU || '');

    if (
      (SonlandirData[0]?.INDIRIMLI_TUTAR_KDVLI || 0) === 0 ||
      (malzeme_toplam + iscilik_toplam + yol_odeme_toplam).toFixed(2) !==
        (SonlandirData[0]?.TOPLAM_FIYAT).toFixed(2) ||
      (SonlandirData[0]?.INDIRIMLI_TUTAR_KDVLI || 0) >
        malzeme_toplam + iscilik_toplam + yol_odeme_toplam
    ) {
      setTahsilatTutarKalan(
        (
          malzeme_toplam +
          iscilik_toplam +
          yol_odeme_toplam -
          (SonlandirData[0]?.TAHSIL_EDILMIS_TUTAR || 0)
        ).toFixed(2)
      );
    } else {
      setTahsilatTutarKalan(
        (
          (SonlandirData[0]?.INDIRIMLI_TUTAR_KDVLI || 0) -
          (SonlandirData[0]?.TAHSIL_EDILMIS_TUTAR || 0)
        ).toFixed(2)
      );
    }

    if (
      parseInt(SonlandirData[0]?.GARANTI_TIPI) === 1 &&
      SonlandirData[0]?.HIZMETLER.filter(
        h => parseInt(h.TIP_KODU) === 7 || parseInt(h.HIZMET_KODU) === 1685
      ).length === 0
    ) {
      setKocailemGoster(true);
      if (!readonly && parseInt(SonlandirData[0]?.KOCAILEM) === 1) {
        applyKocAilem();
      }
    }
  }, [
    FisNo,
    readonly,
    tasks,
    SonlandirData,
    malzeme_toplam,
    iscilik_toplam,
    yol_odeme_toplam,
    applyKocAilem
  ]);

  // Sadece FisNo değiştiğinde 1 kez çağrılacak metodlar
  useEffect(() => {
    if (!FisNo) return;
    handleGetLogisticEmployee();
    RafliKitÜrünDinamikGrupKontrol();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FisNo]);

  useEffect(() => {
    const jobs = loadBaslandiJob();
    if (!SonlandirData && (!Array.isArray(jobs) || jobs.length === 0)) return;
    let activeJob = null;

    if (Array.isArray(SonlandirData) && SonlandirData[0]) {
      activeJob = SonlandirData[0];
    } else {
      activeJob = readonly
        ? Array.isArray(tasks?.tasks)
          ? tasks.tasks.find(d => parseInt(d.FisNo) === parseInt(FisNo))
          : null
        : Array.isArray(jobs) && jobs.length > 0
        ? jobs[0]
        : null;
    }
    if (
      (activeJob?.RafliStackMalzemeKontrolu ?? 0) === 1 &&
      activeJob?.RaflıKitDinamikModelKoduKontrol === 1 &&
      Array.isArray(stackingKitData) &&
      stackingKitData.length > 0
    ) {
      const kalanMalzemeler = (activeJob?.MALZEMELER || []).filter(
        item =>
          !(
            item?.ACIKLAMA?.includes('Sınıf:Bağlantı Kiti Malzemeleri') ||
            item?.SINIF_KODU === 6018
          )
      );

      activeJob = {
        ...activeJob,
        MALZEMELER: kalanMalzemeler
      };
      if (!(Array.isArray(SonlandirData) && SonlandirData[0])) {
        saveBaslandiJob(activeJob);
      }
    }
  }, [SonlandirData, stackingKitData, FisNo, readonly, tasks]);

  const handleChangeDurum = event => {
    if (readonly) {
      return;
    }
    var index = event.target.selectedIndex;
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    job = {
      ...job,
      SON_DURUM: event.target.value
    };
    saveBaslandiJob(job);
    setSonDurum(event.target.value);
    setSonDurumAciklama(event.target[index].text);
  };

  const handleChangeCevrimSayisi = value => {
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    job = {
      ...job,
      CEVRIM_SAYISI: value
    };
    saveBaslandiJob(job);
    setCevrimSayisi(value);
  };

  const handleChangeTahsilatTutar = value => {
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    job = {
      ...job,
      TAHSILAT_TUTAR: value
    };
    saveBaslandiJob(job);
    setTahsilatTutar(value);
  };

  const handleChangeTutar = value => {
    manuelTutarDegisikligiRef.current = true;
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    var TahsilatTutar = 0;
    job = {
      ...job,
      INDIRIMLI_TUTAR_KDVLI: value,
      TAHSILAT_TUTAR: TahsilatTutar
    };
    saveBaslandiJob(job);
    setTutar(value);

    setTahsilatTutarKalan((value - tahsil_edilmis_tutar).toFixed(2));
  };

  const handleChangeIslemYeri = event => {
    if (readonly) {
      return;
    }
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    job = {
      ...job,
      ISLEM_YERI: event.target.value
    };
    saveBaslandiJob(job);
    setIslemYeri(event.target.value);
  };

  const handleChangeTahsilatTipi = event => {
    if (readonly) {
      return;
    }
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    job = {
      ...job,
      TAHSILAT_TIPI: event.target.value
    };
    saveBaslandiJob(job);
    setTahsilatTipi(event.target.value);
  };

  const handleChangeSonucNotu = event => {
    if (readonly) {
      return;
    }
    if (openLegal === false) {
      setOpenLegal(true);
    }

    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    job = {
      ...job,
      SONUC_NOTU: event.target.value
    };
    saveBaslandiJob(job);
    setSonucNotu(event.target.value);
  };
  const handleChangeProjeKodu = event => {
    if (readonly) {
      return;
    }
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    job = {
      ...job,
      PROJE_KODU: event.target.value
    };
    saveBaslandiJob(job);
    setProjeKodu(event.target.value);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };

  const handleBrandModelChange = (index, selectedNames) => {
    setBrandName(prevBrandNames => {
      const newBrandNames = [...prevBrandNames];
      newBrandNames[index] = selectedNames;
      return newBrandNames;
    });
  };

  const handleBrandChange = event => {
    setBenchMarkBrandID(event.target.value);
  };

  const openUrunTercihSoru = () => {
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    if (job?.ARIZA_HATA_KODU === -2) {
      setOpen(true);
      setUyari1(
        'Üründe tespit edilen hata/servis fonksiyon test sonucu kodu seçilmelidir.'
      );
      history.push(`/WorkOrder/${FisNo}/Hizmet`);
      return;
    }
    if (
      parseInt(sonDurum) !== 11 &&
      parseInt(sonDurum) !== 51 &&
      parseInt(sonDurum) !== 52 &&
      parseInt(sonDurum) !== 68
    ) {
      axios
        .get(`/CheckArtemisBenchmarkBrandExistance/${FisNo}`)
        .then(response => {
          if (response.data === 0) {
            seUrunTercihSoru(true);
          } else {
            handleMerkezeGonder();
          }
        });
    } else {
      handleMerkezeGonder();
    }
  };

  const beforeHandleMerkezeGonder = () => {
    axios
      .get(`/GetArtemisBenchmarkBrandProduct`)
      .then(response => {
        if (response.data.length > 0) {
          setBenchmarkBrandData(response.data);
          setBrandName(Array(response.data.length).fill([]));
          seUrunTercihSoru(false);
          setUrunTercihi(true);
        }
      })
      .catch(error => {
        logger.error('Hata detayı:', error.message);
      });
  };
  const beforeHandleMerkezeGonderHayir = () => {
    try {
      const jobs = loadBaslandiJob();
      if (!Array.isArray(jobs) || jobs.length === 0) {
        return; // ya da kontrollü hata
      }
      let job = jobs[0];
      let productSelected = {
        FIS_NO: job.FisNo,
        products: [{ MODEL_ID: '1', MODEL_ADI: 'null' }],
        TEKNISYEN_KODU: job.TEKNISYEN_KODU
      };
      axios
        .post('/SetArtemisBenchmarkProducts', productSelected)
        .then(res => {
          const response = res.data.length === 0 ? [] : res.data;
          if (response.ErrorCode === '0') {
            setLoadingControl(false);
            seUrunTercihSoru(false);
            handleMerkezeGonder();
          } else {
            setLoadingControl(false);
            seUrunTercihSoru(false);
            handleMerkezeGonder();
            return;
          }
        })
        .catch(error => {
          logger.error('Hata detayı:', error.message);
          setLoadingControl(false);
          seUrunTercihSoru(false);
          handleMerkezeGonder();
        });
    } catch (error) {
      handleMerkezeGonder();
      setUrunTercihi(false);
    }
  };

  const handleBrandSave = () => {
    try {
      const selectedModelsArray = [];
      brandName.forEach((selectedNames, index) => {
        selectedNames.forEach(selectedName => {
          const brand = benchmarkBrandData[index];
          const model = brand?.P?.find(
            model => model.MODEL_ADI === selectedName
          );
          if (model) {
            selectedModelsArray.push({
              MODEL_ID: model.MODEL_ID.toString(),
              MODEL_ADI: selectedName
            });
          }
        });
      });
      const jobs = loadBaslandiJob();
      if (!Array.isArray(jobs) || jobs.length === 0) {
        return; // ya da kontrollü hata
      }
      let job = jobs[0];
      let productSelected = {
        FIS_NO: job.FisNo,
        products: selectedModelsArray,
        TEKNISYEN_KODU: job.TEKNISYEN_KODU
      };
      axios
        .post('/SetArtemisBenchmarkProducts', productSelected)
        .then(res => {
          const response = res.data.length === 0 ? [] : res.data;
          if (response.ErrorCode === '0') {
            setUyariTip('success');
            setUyari(true);
            setLoadingControl(false);
            setUyariAciklama(response.ErrorDescription);
            handleMerkezeGonder();
            setUrunTercihi(false);
          } else {
            setUyariTip('error');
            setUyari(true);
            setUyariAciklama(response.ErrorDescription);
            setLoadingControl(false);
            handleMerkezeGonder();
            setUrunTercihi(false);
            return;
          }
        })
        .catch(error => {
          logger.error('Hata detayı:', error.message);
        });
    } catch (error) {
      handleMerkezeGonder();
      setUrunTercihi(false);
    }
  };

  const handleMerkezeGonder = () => {
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    if (lojistikPersonelKontrol === 1 && job?.LojistikPersonelKontrolu !== 1) {
      setPersonalPrimPopUp(true);
      setPersonalEkleme(false);
      job = {
        ...job,
        LojistikPersonelKontrolu: 1
      };
      saveBaslandiJob(job);

      return;
    }
    if (readonly) {
      return;
    }
    const RafliMalzemeVarmi = job?.MALZEMELER?.some(
      item =>
        item.ACIKLAMA?.includes('Sınıf:Bağlantı Kiti Malzemeleri') ||
        item.SINIF_KODU === 6018
    )
      ? 1
      : 0;
    if (
      job?.RaflıKitDinamikModelKoduKontrol === 1 &&
      job?.GARANTI_TIPI === 2 &&
      RafliMalzemeVarmi === 1 &&
      (job?.RafliStackMalzemeKontrolu ?? 0) !== 1
    ) {
      job = {
        ...job,
        RafliStackMalzemeKontrolu: 1
      };
      saveBaslandiJob(job);

      confirmAlert({
        message:
          'Normal Stacking Kit yerine Raflı Stacking Kit satışı isteniyor mu? Not: Otomatik fiş oluşacak ve tüketiciden ücret farklı alınacaktır.',
        buttons: [
          {
            label: 'Evet',
            onClick: () => handleMalzemeSecimiPopUp()
          },
          {
            label: 'Hayır',
            onClick: () => {
              handleMerkezeGonder();
              return;
            }
          }
        ]
      });
      return;
    }
    if (!checkValidBarkod()) {
      confirmAlert({
        message:
          'Okutulan barkod ile seçilen ürün bilgileri uyuşmuyor. Devam etmek istiyor musunuz?',
        buttons: [
          {
            label: 'Evet',
            onClick: () => handleMerkezeGonderIlkEvet()
          },
          {
            label: 'Hayır',
            onClick: () => {
              return;
            }
          }
        ]
      });
    } else {
      handleMerkezeGonderIlkEvet();
    }
  };

  const handleMerkezeGonderIlkEvet = async () => {
    if (readonly) {
      return;
    }

    const MerkezeGonderilecekData1 = loadBaslandiJob();
    if (
      !Array.isArray(MerkezeGonderilecekData1) ||
      MerkezeGonderilecekData1.length === 0
    ) {
      return;
    }

    let durum1 = parseInt(sonDurum);
    var KalanBorc = 0;
    if (durum1 === 4 || durum1 === 45) {
      if (
        MerkezeGonderilecekData1[0]?.INDIRIMLI_TUTAR_KDVLI === '' ||
        MerkezeGonderilecekData1[0]?.INDIRIMLI_TUTAR_KDVLI === undefined ||
        MerkezeGonderilecekData1[0]?.INDIRIMLI_TUTAR_KDVLI === '0'
      ) {
        KalanBorc = (
          malzeme_toplam +
          iscilik_toplam +
          yol_odeme_toplam -
          (SonlandirData[0]?.TAHSIL_EDILMIS_TUTAR || 0) -
          (MerkezeGonderilecekData1[0]?.TAHSILAT_TUTAR || 0)
        ).toFixed(2);
      } else {
        KalanBorc = (
          MerkezeGonderilecekData1[0]?.INDIRIMLI_TUTAR_KDVLI -
          (SonlandirData[0]?.TAHSIL_EDILMIS_TUTAR || 0) -
          (MerkezeGonderilecekData1[0]?.TAHSILAT_TUTAR || 0)
        ).toFixed(2);
      }
    }

    var KalanBorcUyari = '';
    if (
      (durum1 === 4 || durum1 === 45) &&
      (parseInt(MerkezeGonderilecekData1[0]?.TAHSILAT_TIPI) || 0) !== 4 &&
      (MerkezeGonderilecekData1[0]?.TAHSILAT_TUTAR || 0) === 0
    ) {
      KalanBorcUyari =
        'Müşterimizden ' +
        KalanBorc +
        ' ₺ tahsilat yapıyorsunuz. Eğer kısmi tahsilat yaptıysanız tahsilat tutarına giriş yapınız. Hiç tahsilat yapmadıysanız tahsilat tipi borç seçiniz!... Devam etmek istiyor musunuz?';
      const jobs = loadBaslandiJob();
      if (!Array.isArray(jobs) || jobs.length === 0) {
        return; // ya da kontrollü hata
      }
      let job = jobs[0];
      job = {
        ...job,
        TAHSILAT_TUTAR: KalanBorc
      };
      saveBaslandiJob(job);
      setTahsilatTutar(KalanBorc);
    } else {
      KalanBorcUyari =
        'Müşterimizin tahsil edilmemiş ' +
        KalanBorc +
        ' ₺ borçu kalacak. Emin misiniz? Devam etmek istiyor musunuz?';
    }

    if (parseInt(MerkezeGonderilecekData1[0]?.GARANTI_TIPI) !== 1) {
      KalanBorc = 0;
    }

    if (KalanBorc > 0) {
      confirmAlert({
        message: KalanBorcUyari,
        buttons: [
          {
            label: 'Evet',
            onClick: () => handleMerkezeGonderEvet()
          },
          {
            label: 'Hayır',
            onClick: () => {
              return;
            }
          }
        ]
      });
    } else {
      handleMerkezeGonderEvet();
    }
  };

  const handleMerkezeGonderEvet = async () => {
    if (readonly) {
      return;
    }
    try {
      setLoadingControl(true);
      let anket = await anketKontrol();
      let durum = parseInt(sonDurum);
      if (anket !== 0) {
        if (durum === 4 || durum === 45) {
          // kapat ya da ofiste kapat
          setUyari1('Önce Anket İşlemlerini Tamamlayınız!..');
          setOpen(true);
          history.push(`/WorkOrder/${FisNo}/Anket`);
          setLoadingControl(false);
          return;
        }
      }
      const ankastreAnket = await ankastreAnketKontrol();
      const urunKontrol = await ankastreUrunKontrol();
      const jobs = loadBaslandiJob();
      if (!Array.isArray(jobs) || jobs.length === 0) {
        return; // ya da kontrollü hata
      }
      let job = jobs[0];
      let isAnkastreMontaj =
        Array.isArray(job.HIZMETLER) &&
        job.HIZMETLER.some(item =>
          [503, 566, 1520, 1521, 1700].includes(item.HIZMET_KODU)
        ) &&
        !job.HIZMETLER.some(item => item.HIZMET_KODU === 235) &&
        !job.HIZMETLER.some(item =>
          [439, 3160, 3161, 3157].includes(item.HIZMET_KODU)
        ) &&
        urunKontrol === 1;
      if (
        ankastreAnket === 0 &&
        (durum === 4 || durum === 45) &&
        isAnkastreMontaj
      ) {
        setUyari2('Önce Ankastre Montaj Anketini Tamamlayınız!..');
        setOpen2(true);
        setLoadingControl(false);
        return;
      }
      await uploadFotograf(FisNo);
      let MerkezeGonderilecekData = loadBaslandiJob();
      if (checkHomewhiz(true) && !MerkezeGonderilecekData[0]?.HOMEWHIZ_UYARI) {
        saveBaslandiJob({ ...MerkezeGonderilecekData[0], HOMEWHIZ_UYARI: 1 });
        setUyari1(
          'Tüm deneme ve kurulumlar kullanıcı akıllı cihazı üzerinden ve kullanıcı bilgileri kullanılarak yapılmalıdır!.. Bu bir bilgilendirme mesajıdır, fişinizi tekrar gönderebilirsiniz.'
        );
        setOpen(true);
        setLoadingControl(false);
        return;
      }
      let onboard = await onboardKontrol();
      if (onboard !== 0) {
        setUyari1(
          'Ürün Homewhiz özelliklidir. Homewhiz kurulumunu yapınız.Kurulumdan sonra 456 kod girişi aktif olacaktır!..'
        );
        setOpen(true);
        setLoadingControl(false);
        return;
      }

      var DurumEnlem = getKoordinat('Enlem');
      var DurumBoylam = getKoordinat('Boylam');
      let FarkliSms = 0;
      if (MerkezeGonderilecekData[0]?.FARKLI_SMS === true) {
        FarkliSms = 1;
      }
      const SessionUser = getUser();
      const data = [
        {
          BASVURU_NO: parseInt(MerkezeGonderilecekData[0]?.BasvuruNo) || 0,
          BIRIM_KODU: parseInt(MerkezeGonderilecekData[0]?.BIRIM_KODU) || 0,
          FIS_NO: parseInt(MerkezeGonderilecekData[0]?.FisNo) || 0,
          MUSTERI_NO: parseInt(MerkezeGonderilecekData[0]?.MusteriNo) || 0,
          TEKNISYEN_KODU:
            parseInt(MerkezeGonderilecekData[0]?.TEKNISYEN_KODU) || 0,
          BARKOD: MerkezeGonderilecekData[0]?.BARKOD || '',
          BARKOD_ENLEM: MerkezeGonderilecekData[0]?.BARKODENLEM || '',
          BARKOD_BOYLAM: MerkezeGonderilecekData[0]?.BARKODBOYLAM || '',
          BARKOD_OKUMA_TARIH: MerkezeGonderilecekData[0]?.BARKODTARIH || '',
          KUL_MODEL_KODU: MerkezeGonderilecekData[0]?.KUL_MODEL_KODU || '',
          UYIL: parseInt(MerkezeGonderilecekData[0]?.UYIL) || 0,
          UDONEM: parseInt(MerkezeGonderilecekData[0]?.UDONEM) || 0,
          SERINO: parseInt(MerkezeGonderilecekData[0]?.SERINO) || 0,
          NITELIK_KODU: parseInt(MerkezeGonderilecekData[0]?.NITELIK_KODU) || 0,
          GARANTI_TARIHI: MerkezeGonderilecekData[0]?.GARANTI_TARIHI || '',
          GARANTI_TIPI: parseInt(MerkezeGonderilecekData[0]?.GARANTI_TIPI) || 0,
          GELINEN_YER: MerkezeGonderilecekData[0]?.GELINEN_YER || '',
          GIDILEN_YER: MerkezeGonderilecekData[0]?.GIDILEN_YER || '',
          PLAKA: MerkezeGonderilecekData[0]?.PLAKA || '',
          MESAFE: parseInt(MerkezeGonderilecekData[0]?.MESAFE) || 0,
          FARKLI_SMS: parseInt(FarkliSms) || 0,
          SMS_ALICI_ADI: MerkezeGonderilecekData[0]?.SMS_ALICI_ADI || '',
          SMS_ALICI_SOYADI: MerkezeGonderilecekData[0]?.SMS_ALICI_SOYADI || '',
          SMS_GSM: MerkezeGonderilecekData[0]?.ALICI_GSM || '',
          SMS_KOD: MerkezeGonderilecekData[0]?.ALINAN_SMS_KOD || '',
          DURUM: parseInt(MerkezeGonderilecekData[0]?.SON_DURUM) || 4,
          BAYI_KODU: parseInt(MerkezeGonderilecekData[0]?.BAYI_KODU) || 0,
          ISLEM_YERI: parseInt(MerkezeGonderilecekData[0]?.ISLEM_YERI) || 0,
          SONUC_NOTU: MerkezeGonderilecekData[0]?.SONUC_NOTU || '',
          HIZMET_NOTU: MerkezeGonderilecekData[0]?.HIZMET_NOTU || '',
          DURUM_ENLEM: DurumEnlem || '',
          DURUM_BOYLAM: DurumBoylam || '',
          BASVURU_NEDENI: MerkezeGonderilecekData[0]?.BasvuruNedeni || '',
          TAHSILAT_TIPI:
            parseInt(MerkezeGonderilecekData[0]?.TAHSILAT_TIPI) || 0,
          INDIRIMLI_TUTAR_KDVLI:
            MerkezeGonderilecekData[0]?.INDIRIMLI_TUTAR_KDVLI || 0,
          ESKI_IMEI: MerkezeGonderilecekData[0]?.EskiImei || '',
          YENI_IMEI: MerkezeGonderilecekData[0]?.YeniImei || '',
          IMSI: MerkezeGonderilecekData[0]?.Imsi || '',
          PROJE_KODU: MerkezeGonderilecekData[0]?.PROJE_KODU || '',
          DEZENFEKSIYON_METREKARE:
            parseInt(MerkezeGonderilecekData[0]?.DEZENFEKSIYON_METREKARE) || 0,
          DEZENFEKSIYON_TUTAR:
            MerkezeGonderilecekData[0]?.DEZENFEKSIYON_TUTAR || 189,
          USER_ID: parseInt(SessionUser.OrganizationUserId) || 0,
          UDS_MUSTERI_TIPI: MerkezeGonderilecekData[0]?.UDS_MUSTERI_TIPI || 0,
          UDS_NEDEN_DETAY: MerkezeGonderilecekData[0]?.UDS_NEDEN_DETAY || 0,
          UDS_TUR: MerkezeGonderilecekData[0]?.UDS_TUR || 0,
          UDS_TUTAR: MerkezeGonderilecekData[0]?.UDS_TUTAR || 0,
          UDS_459_IADE_NEDEN:
            MerkezeGonderilecekData[0]?.UDS_459_IADE_NEDEN || 0,
          UDS_459_IADE_NEDEN_ACIKLAMA:
            MerkezeGonderilecekData[0]?.UDS_459_IADE_NEDEN_ACIKLAMA || '',
          MEG_TANIMLAMA_NEDENI:
            MerkezeGonderilecekData[0]?.MEG_TANIMLAMA_NEDENI || 0,
          MEG_TANIMLAMA_YIL: MerkezeGonderilecekData[0]?.MEG_TANIMLAMA_YIL || 0,
          UDS_BANKA_KODU: MerkezeGonderilecekData[0]?.UDS_BANKA_KODU || '',
          UDS_BANKA_ADI: MerkezeGonderilecekData[0]?.UDS_BANKA_ADI || '',
          UDS_IBANNO: MerkezeGonderilecekData[0]?.UDS_IBANNO || '',
          UDS_FATURA_NO: MerkezeGonderilecekData[0]?.UDS_FATURA_NO || '',
          UDS_FATURA_ADET: MerkezeGonderilecekData[0]?.UDS_FATURA_ADET || 0,
          UDS_FATURA_TARIHI:
            MerkezeGonderilecekData[0]?.UDS_FATURA_TARIHI || '',
          UDS_FATURA_TUTARI: MerkezeGonderilecekData[0]?.UDS_FATURA_TUTARI || 0,
          UDS_TEMINSIZ_STOK_KUL_KODU:
            MerkezeGonderilecekData[0]?.UDS_TEMINSIZ_STOK_KUL_KODU || '',
          UDS_KISANOT: MerkezeGonderilecekData[0]?.UDS_KISANOT || '',
          UDS_SERVIS_NOTU: MerkezeGonderilecekData[0]?.UDS_SERVIS_NOTU || '',
          UDS_TALEP_EDILEN_MODEL_KODU:
            MerkezeGonderilecekData[0]?.UDS_TALEP_EDILEN_MODEL_KODU.toString() ||
            '0',
          UDS_DEKONT_SAHIBI:
            MerkezeGonderilecekData[0]?.UDS_DEKONT_SAHIBI || '',
          UDS_UST_MODEL_FARK_TUTAR:
            MerkezeGonderilecekData[0]?.UDS_UST_MODEL_FARK_TUTAR || 0,
          UDS_FATURA_SIRA: MerkezeGonderilecekData[0]?.UDS_FATURA_SIRA || 0,
          UDS_VERGI_DAIRESI:
            MerkezeGonderilecekData[0]?.UDS_VERGI_DAIRESI || '',
          UDS_VERGI_DAIRESI_ID:
            MerkezeGonderilecekData[0]?.UDS_VERGI_DAIRESI_ID || 0,
          UDS_VERGI_DAIRESI_KOD:
            MerkezeGonderilecekData[0]?.UDS_VERGI_DAIRESI_KOD || '',
          UDS_VERGI_NUMARASI:
            MerkezeGonderilecekData[0]?.UDS_VERGI_NUMARASI || '',
          UDS_SERVIS_URUNU_TESLIM_ALDI:
            (MerkezeGonderilecekData[0]?.UDS_SERVIS_URUNU_TESLIM_ALDI ===
              true ||
            MerkezeGonderilecekData[0]?.UDS_SERVIS_URUNU_TESLIM_ALDI === 1
              ? 1
              : 0) || 0,
          UDS_TCKIMLIKNO: MerkezeGonderilecekData[0]?.UDS_TCKIMLIKNO || '',
          UDS_TUKETICI_BILGILERI_DEGISIKLIK_SEBEBI:
            MerkezeGonderilecekData[0]
              .UDS_TUKETICI_BILGILERI_DEGISIKLIK_SEBEBI || '',
          CEVRIM_SAYISI:
            parseInt(MerkezeGonderilecekData[0]?.CEVRIM_SAYISI) || 0,
          HIZMETLER: (MerkezeGonderilecekData[0]?.HIZMETLER || []).map(h => {
            return { HIZMET_KODU: h.HIZMET_KODU };
          }),
          ISCILIKLER: MerkezeGonderilecekData[0]?.ISCILIKLER || [],
          MALZEMELER: MerkezeGonderilecekData[0]?.MALZEMELER || [],
          NORMAL_URUN_ISARET:
            MerkezeGonderilecekData[0]?.NORMAL_URUN_ISARET || false,
          TAHSILAT_TUTAR: MerkezeGonderilecekData[0]?.TAHSILAT_TUTAR || 0,
          SOLAR_BARKOD: MerkezeGonderilecekData[0]?.SolarBarcode || '',
          ARIZA_HATA_KODU:
            MerkezeGonderilecekData[0]?.ARIZA_HATA_KODU?.toString() || '',
          MUSTERININ_FARKLI_MODEL_TALEBI:
            MerkezeGonderilecekData[0]?.MUSTERININ_FARKLI_MODEL_TALEBI
        }
      ];

      const config = {
        headers: { 'Content-Type': 'application/json' }
      };

      axios
        .post('/SetArtemisSendtoCenter', data, config)
        .then(response => {
          setLoadingControl(false);
          let ResponseData = response.data[0];
          if (parseInt(ResponseData.ErrorCode) !== 0) {
            if (
              (ResponseData.ErrorDescription || '').split(':')[0] ===
              'Dogrulama-9999'
            ) {
              let MesajDogrula = ResponseData.ErrorDescription.replace(
                'Dogrulama-9999:',
                ''
              ).split(',');
              confirmAlert({
                message: MesajDogrula.map(m => (
                  <div>
                    <ListItem alignItems="flex-start">
                      <ListItemText primary={m} />
                    </ListItem>
                    <Divider className={classes.divider} />
                  </div>
                )),
                buttons: [
                  { label: 'Gönder', onClick: () => handleMerkezeGonderEvet() },
                  {
                    label: 'Gönderme',
                    onClick: () => {
                      setUyari(false);
                      return;
                    }
                  }
                ]
              });
            } else if (
              ResponseData.ErrorDescription.split(':')[0] === 'ZIMMET'
            ) {
              // setUyariTip('warning');
              // setUyariAciklama('Zimmet işlemlerini tamamlayınız!..');
              setDebitOpen(true);
              return;
            } else if (ResponseData.ErrorDescription.split(':')[0] === 'İade') {
              setOpenUDGNedenPopUp(true);
              return;
            } else if (ResponseData.ErrorDescription.split(':')[0] === 'MEG') {
              setMEGOpenPopUp(true);
              return;
            } else {
              setUyariTip('error');
              setUyariAciklama(ResponseData.ErrorDescription);
            }
          } else {
            setUyariTip('success');
            setUyariAciklama(ResponseData.ErrorDescription);
            setReadonly(true);

            // Sigorta satış fırsatı kontrolü
            // Fiş kapatıldı mı? (4: Kapat, 45: Ofiste Kapat)
            const isFisClosed =
              parseInt(sonDurum) === 4 || parseInt(sonDurum) === 45;

            if (isFisClosed && InsuranceVisible) {
              setInsuranceSalesPopup(true);
            }

            if (
              MerkezeGonderilecekData[0]?.GARANTI_TIPI === 1 &&
              MerkezeGonderilecekData[0]?.AramaIzin === 1 &&
              (MerkezeGonderilecekData[0]?.Marka === 'Arçelik' ||
                MerkezeGonderilecekData[0]?.Marka === 'Beko')
            ) {
              //1602  --> 440 Ürün Kontrolü ve Arıza Tespiti (Garanti Dışında Kullanılacak)
              if (
                SonlandirData[0]?.HIZMETLER.filter(
                  Hizmet => parseInt(Hizmet.HIZMET_KODU) === 1602
                ).length > 0
              ) {
                MusteriYeniUrunKampanyaSoru(
                  parseInt(MerkezeGonderilecekData[0]?.FisNo) || 0,
                  parseInt(MerkezeGonderilecekData[0]?.MusteriNo) || 0
                );
              }
            }
            const jobs = loadBaslandiJob();
            if (!Array.isArray(jobs) || jobs.length === 0) {
              return; // ya da kontrollü hata
            }
            let job = jobs[0];
            job = {
              ...job,
              DurumKodu: sonDurum || '4',
              Durum: sonDurumAciklama || 'Kapat (Hizmet Tamamlandı)',
              DurumKoduArama: sonDurum || '4',
              ALICI_GSM: MerkezeGonderilecekData[0]?.ALICI_GSM || ''
            };
            var DATAAItip = MerkezeGonderilecekData[0]?.DATAAI_TIP;
            setTask(job);
            removeBaslandiJob();

            if (DATAAItip === '2') {
              setDATAAI_TIP(MerkezeGonderilecekData[0]?.DATAAI_TIP);
              setDATAAI_PopupText(
                'Müşterimizde Ek Garanti Satış Fırsatı Var!...'
              );
              setDATAAI_Popup(true);
            }
            if (DATAAItip === '4') {
              setDATAAI_TIP(MerkezeGonderilecekData[0]?.DATAAI_TIP);
              setDATAAI_PopupText(
                'Müşterimizde Tamamlayıcı Ürün Satış Fırsatı Var!...'
              );
              setDATAAI_Popup(true);
            }
            if (DATAAItip === '5') {
              setDATAAI_TIP(MerkezeGonderilecekData[0]?.DATAAI_TIP);
              setDATAAI_PopupText('Müşterimizde Bakım Satış Fırsatı Var!...');
              setDATAAI_Popup(true);
            }
          }
          setUyari(true);
        })
        .catch(error => {
          setLoadingControl(false);
          setUyariTip('error');
          setUyariAciklama('Bir hata oluştu!.. ' + error.message);
          setUyari(true);
        });
    } catch (error) {
      setLoadingControl(false);
      setUyariTip('error');
      setUyariAciklama('Bir hata oluştu!.. ' + error.message);
      setUyari(true);
    }
  };

  const alertMessage = (tip, aciklama) => {
    setUyariTip(tip);
    setUyariAciklama(aciklama);
    setUyari(true);
  };

  const handleKartBarkodClose = async () => {
    setOpenUDGNedenPopUp(false);
  };

  const handleMEGPopUpClose = async () => {
    setMEGOpenPopUp(false);
    let MeGData = loadBaslandiJob();
    const SERINO = parseInt(MeGData[0]?.SERINO);
    setUyariAciklama(
      SERINO +
        ' Seri Numaralı Ürüne Memnuniyet Ek Garantisi Tanımlanacak ve tüketiciye ücretsiz ek garanti tanımlandığına dair bilgilendirme sms’i gönderilecektir.'
    );
  };

  const handleQrBarkodClose = async barkod => {
    setOpenQrBarkod(false);
    if (barkod.length !== undefined) {
      handleOlizMüsteriTokenAl(barkod);
    }
  };

  const handleClosePayPopupOpen = () => {
    setTokenPayPopupOpen(false);
  };

  const handleCloseDepositPopupOpen = () => {
    setDepositProductPopUp(false);
  };

  const handleOlizMüsteriTokenAl = QrBarkod => {
    if (readonly) {
      return;
    }
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    if (QrBarkod.length === 8) {
      let totalPrice = (job.ISCILIK_TOPLAM || 0) + (job.MALZEME_TOPLAM || 0);
      var HizmetOlizParam = '';
      job.HIZMETLER.forEach(element => {
        HizmetOlizParam += element.HIZMET_KODU + ',';
      });
      axios
        .get(
          `GetOlizAlisverisBaslat/${FisNo}/${QrBarkod}/${'4'}/${totalPrice}/${
            job.KUL_MODEL_KODU
          }/${HizmetOlizParam}`
        )
        .then(response => {
          var ResponseData = response.data;
          var AlisverisData = ResponseData.XmlString;
          if (AlisverisData?.SONUC === '1') {
            if (totalPrice <= 0) {
              return;
            }
            if (AlisverisData?.INDIRIM.URUNINDIRIMLIST !== '') {
              let indirim =
                AlisverisData.INDIRIM.URUNINDIRIMLIST.URUNINDIRIM.UINDTUTAR;
              indirim = indirim.replace(',', '.');
              var newPrice = 0;
              newPrice = AlisverisData.INDIRIM.YENIAVTUTAR;
              newPrice = newPrice.replace(',', '.');
              job = {
                ...job,
                INDIRIMLI_TUTAR_KDVLI: newPrice
              };
              saveBaslandiJob(job);
              setTutar(newPrice);
              setTahsilatTutarKalan(newPrice);
              alertMessage(
                'success',
                `Oliz Garanti Dışı Hizmet programı kapsamında ${totalPrice.toFixed(
                  2
                )}₺ işlem üzerinden ${indirim}₺ indirim uygulandı.`
              );
              const config = {
                headers: { 'Content-Type': 'application/json' }
              };
              var data = {
                FisNo: FisNo,
                TRXNO: AlisverisData.TRXNO,
                Token: QrBarkod,
                Tutar: newPrice
              };
              axios
                .post('/SetOlizAlisverisBaslat', data, config)
                .then(response => {
                  setLoadingControl(false);
                  const res = response.data;
                  if (parseInt(res.ErrorCode) !== 0) {
                  }
                });
            }
          } else {
            alertMessage('error', `${AlisverisData?.ACIKLAMA}`);
          }
        })
        .catch(error => {
          // 404 hatası veya diğer hataları sessizce logla
          console.warn('Oliz API hatası:', error.message);
        });
    }
  };

  const handleTokenPayCreditSend = () => {
    setTokenPayPopupOpen(true);
  };
  const handleSmsGonderSmsAl = (
    event,
    Telefon,
    tip,
    FisNo,
    Musteri,
    TelefonOffline,
    MarkaKodu
  ) => {
    var Uyari = '';
    var TutarDeger = 0;
    if (TahsilatTutar === '' || TahsilatTutar === 0) {
      TutarDeger = (malzeme_toplam + iscilik_toplam + yol_odeme_toplam).toFixed(
        2
      );
    } else {
      TutarDeger = TahsilatTutar;
    }

    if (TutarDeger < 1) {
      TutarDeger = parseFloat(SonlandirData[0]?.EK_GARANTI_FIYAT || 0);
    }

    Uyari +=
      Musteri +
      ' ın ' +
      Telefon +
      ' numaralı telefonuna gönderilecek ödeme linki ile ' +
      TutarDeger.toString() +
      ' tl ödeme alınacaktır. Devam etmek ister misin?';
    const confirmation = window.confirm(Uyari);
    if (!confirmation) {
      return;
    }

    setLoadingControl(true);
    var Marka = '';

    if (parseInt(MarkaKodu) === 4) {
      Marka = 'Beko';
    } else {
      Marka = 'Arçelik';
    }
    const SessionUser = getUser();

    const data = [
      {
        FisNo: FisNo,
        Musteri: Musteri,
        Telefon: TelefonOffline,
        Tutar: TutarDeger,
        Marka: Marka,
        KullaniciId: SessionUser.OrganizationUserId
      }
    ];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetTokenPaySmsOdeme', JSON.stringify(data), config)
      .then(response => {
        setLoadingControl(false);
        setTokenPayPopupOpen(false);
        const res = response.data;
        if (res !== 'ok') {
          setUyariTip('error');
          setUyariAciklama(res);
        } else {
          setUyariTip('success');
          setUyariAciklama('Sms Ödeme Linki Gönderildi!...');
        }
        setUyari(true);
      });
  };

  const MusteriYeniUrunKampanyaSoru = (FisNo, MusteriNo) => {
    if (FisNo === 0 || MusteriNo === 0) {
      return;
    }
    axios
      .get(`GetCustomerNewProductQuestionAvailability/${FisNo}`)
      .then(response => {
        if (parseInt(response.data.ErrorCode) === 0) {
          confirmAlert({
            message: 'Tüketicinin yeni ürün alma planı/düşüncesi var mı?',
            buttons: [
              {
                label: 'Evet',
                onClick: () => {
                  MusteriYeniUrunKampanyaSoruCevapGonder(
                    FisNo,
                    MusteriNo,
                    true
                  );
                }
              },
              {
                label: 'Hayır',
                onClick: () => {
                  MusteriYeniUrunKampanyaSoruCevapGonder(
                    FisNo,
                    MusteriNo,
                    false
                  );
                }
              }
            ]
          });
        }
      });
  };

  const MusteriYeniUrunKampanyaSoruCevapGonder = (FisNo, MusteriNo, Cevap) => {
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    var data = {
      ServicePaperId: FisNo,
      CustomerId: MusteriNo,
      Answer: Cevap
    };

    axios
      .post('/SendAnswerCustomerNewProduct', data, config)
      .then(response => {
        setLoadingControl(false);
        const res = response.data;
        if (parseInt(res.ErrorCode) !== 0) {
          setUyariTip('error');
          setUyariAciklama(res.ErrorDescription);
          setUyari(true);
        } else {
          if (Cevap) {
            setUyariTip('success');
            setUyariAciklama(
              'İşleminiz Başarı ile gerçekleştirildi. Kampanya kodu sms ile müşteriye iletilecektir.'
            );
            setUyari(true);
          }
        }
      })
      .catch(error => {
        logger.error('Hata detayı:', error.message);
      });
  };

  const ChangeFilter = value => {
    value = value.replaceAll(' ', '');
    if (value.substring(0, 1) === '0') {
      value = value.substring(1, value.length);
    }
    setFilterPaper(value);
  };

  const handleConfirmIcUniteKlima = () => {
    axios
      .get(`SetKlimaIcUniteFisOlustur/${SonlandirData[0]?.FisNo}`)
      .then(response => {
        setUyari(true);
        setUyariAciklama(response.data || 'İşlem başarılı.');
        setUyariTip('success');
        setConfirmOpenIcUniteKlima(false);
      })
      .catch(error => {
        const message =
          typeof error.response?.data === 'string'
            ? error.response.data
            : error.response?.data?.error ||
              error.response?.data?.message ||
              error.message ||
              'Bağlantı hatası oluştu, lütfen tekrar deneyin.';

        setUyari(true);
        setUyariAciklama(message);
        setUyariTip('error');
        setConfirmOpenIcUniteKlima(false);
      });
  };

  const handleKlimaIcUniteFisOlustur = () => {
    setConfirmOpenIcUniteKlima(true);
  };

  const handleTokenPayCreditControl = () => {
    axios
      .get(`GetOderoPaymentControl/${SonlandirData[0]?.FisNo}`)
      .then(response => {
        setUyari(true);
        setUyariAciklama(response.data);
        setUyariTip('success');
      });
  };

  const setFirsatYonlendir = () => {
    if (DATAAI_TIP === '2') {
      history.push(`/WorkOrder/${FisNo}/EkGaranti`);
    }
    if (DATAAI_TIP === '4') {
      history.push(`/WorkOrder/${FisNo}/TamamlayiciUrunSatis`);
    }
    if (DATAAI_TIP === '5') {
      history.push(`/WorkOrder/${FisNo}/Bakim`);
    }
  };

  const handleConsumerNewProduct = event => {
    const isChecked = event.target.checked;
    setState({
      ...state,
      [event.target.name]: isChecked,
      URUN_KULLANILABILIR: isChecked ? false : state.URUN_KULLANILABILIR // İşaretlendiğinde diğer checkbox iptal edilir
    });

    if (isChecked) {
      confirmAlert({
        message:
          'Tüketici emanet ürün istiyor olarak işaretlemek üzeresiniz, eğer bu işaretlemeyi yaparsanız hizmet fişi Emanet Ürün Talebi durumuna gelecek ve YS ofisine yönlendirilecektir, ilerlemek istiyor musunuz?',
        buttons: [
          {
            label: 'Evet',
            onClick: () => {
              handleConsumerNewProductYes(isChecked, 'EMANET_URUN');
            }
          },
          {
            label: 'Hayır',
            onClick: () => {
              MusteriYeniUrunKampanyaSoruCevapGonder();
            }
          }
        ],
        overlayClassName: 'confirmOverlay',
        className: 'confirmOverlay'
      });
    }
  };

  const handleConsumerNewProductYes = (isChecked, name) => {
    if (readonly) {
      return;
    }

    // Veri oluşturma ve API çağrısı yapılmadan önce işleme alınması
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) {
      return; // ya da kontrollü hata
    }
    let job = jobs[0];
    const SessionUser = getUser();

    const updatedState = {
      ...state,
      [name]: isChecked,
      URUN_KULLANILABILIR: isChecked ? false : state.URUN_KULLANILABILIR
    };

    const data = {
      FIS_NO: job.FisNo,
      SICIL_NO: SessionUser.UserId,
      EMANET_URUN_TALEBI: updatedState.EMANET_URUN
        ? 1
        : updatedState.URUN_KULLANILABILIR
        ? 0
        : -1 // Null yerine backend'in anlayacağı özel bir değer gönder
    };

    // API çağrısını yap
    const config1 = {
      headers: { 'Content-Type': 'application/json' }
    };

    setLoadingControl(true);

    let isMounted = true;
    axios
      .post('/SetArtemisEmanetUrunTalebi', data, config1)
      .then(response => {
        if (!isMounted) return;
        let ResponseData1 = response.data;
        setLoadingControl(false);
        setDepositProductPopUp(false);
        // İşlem sonucuna göre kullanıcıya geri bildirimde bulun
        if (parseInt(ResponseData1.ErrorCode) !== 0) {
          setUyariTip('error');
          setUyariAciklama(ResponseData1.ErrorDescription);
        } else {
          setUyariTip('success');
          setUyariAciklama(ResponseData1.ErrorDescription);
        }
        setUyari(true);

        // SON_DURUM güncellemesi
        job = {
          ...job,
          SON_DURUM: 92
        };
        saveBaslandiJob(job);
        setSonDurum(92);
        setSonDurumAciklama('Emanet Ürün Talebi');
        openUrunTercihSoru();
      })
      .catch(error => {
        if (!isMounted) return;
        // Hata durumunda kullanıcıya bilgi ver
        setLoadingControl(false);
        setUyariTip('error');
        setUyariAciklama('Bir hata oluştu. Lütfen tekrar deneyin.');
        setUyari(true);
        logger.error('Hata detayı:', error.message);
      });
  };

  const handleChange = event => {
    const isChecked = event.target.checked;
    const name = event.target.name;

    // State güncellemesini yap
    setState(prevState => {
      const updatedState = {
        ...prevState,
        [name]: isChecked,
        EMANET_URUN: isChecked ? false : prevState.EMANET_URUN
      };
      const jobs = loadBaslandiJob();
      if (!Array.isArray(jobs) || jobs.length === 0) {
        return; // ya da kontrollü hata
      }
      let job = jobs[0];
      const SessionUser = getUser();
      const data = {
        FIS_NO: job.FisNo,
        SICIL_NO: SessionUser.UserId,
        EMANET_URUN_TALEBI: updatedState.EMANET_URUN
          ? 1
          : updatedState.URUN_KULLANILABILIR
          ? 0
          : -1
      };
      const config1 = {
        headers: { 'Content-Type': 'application/json' }
      };
      setLoadingControl(true);
      axios
        .post('/SetArtemisEmanetUrunTalebi', data, config1)
        .then(response => {
          let ResponseData1 = response.data;
          setLoadingControl(false);
          if (parseInt(ResponseData1.ErrorCode) !== 0) {
            setUyariTip('error');
            setUyariAciklama(ResponseData1.ErrorDescription);
          } else {
            setUyariTip('success');
            setUyariAciklama(ResponseData1.ErrorDescription);
          }
          setUyari(true);
        })
        .catch(error => {
          setUyariTip('error');
          setUyariAciklama('Bir hata oluştu. Lütfen tekrar deneyin.');
          setUyari(true);
          logger.error('Hata detayı:', error.message);
        });
      return updatedState;
    });
  };

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader title={text('Sonlandır')} />

      <Divider />
      {uyari ? (
        <Alert
          onClose={uyariKapat}
          open={uyari}
          message={uyariAciklama || ''}
          variant={uyariTip}
        />
      ) : (
        <div></div>
      )}
      <CardContent className={classes.content}>
        <Dialog
          open={DATAAI_Popup}
          onClose={() => setDATAAI_Popup(false)}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">
            {'Yapay Zeka Öneriyor'}
          </DialogTitle>
          <Divider />
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {DATAAI_PopupText}
            </DialogContentText>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              size="small"
              onClick={() => setFirsatYonlendir()}
              endIcon={<LocalOfferIcon>Kapat</LocalOfferIcon>}
            >
              TeklİfEt
            </Button>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              size="small"
              onClick={() => setDATAAI_Popup(false)}
              endIcon={<CloseIcon>Kapat</CloseIcon>}
            >
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">
            {'Bilgilendirme'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {Uyari1}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)} color="primary">
              Tamam
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={open2}
          onClose={() => setOpen2(false)}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">
            {'Bilgilendirme'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {Uyari2}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => handleAnkastreKontrolDialog()}
              color="primary"
            >
              Tamam
            </Button>
          </DialogActions>
        </Dialog>
        {kocailemOpen && (
          <KocailemVerification
            open={kocailemOpen}
            setOpen={setKocailemOpen}
            FisNo={FisNo}
            setTutar={setTutar}
            alertMessage={alertMessage}
          />
        )}
        {debitOpen && (
          <MaterialDebitVerification
            open={debitOpen}
            setOpen={setDebitOpen}
            alertMessage={alertMessage}
          />
        )}
        {LoadingControl ? (
          <CircularProgress status={'loading'} style={{ marginLeft: '50%' }} />
        ) : (
          <form
            className={clsx(classes.root, className)}
            onSubmit={handleSubmit}
          >
            <div className={classes.fields}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel
                  id="demo-simple-select-outlined-label"
                  disabled={readonly}
                >
                  {text('Durum')}
                </InputLabel>
                <Select
                  fullWidth
                  native
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  onChange={handleChangeDurum}
                  label={text('Durum')}
                  disabled={readonly}
                  value={sonDurum || '4'}
                >
                  <option value={4}>Kapat (Hizmet Tamamlandı)</option>
                  <option value={45}>Fiş Ofiste Kapatılacak</option>
                  <option value={10}>Ürüne Test Cihazı Bırakıldı</option>
                  <option value={11}>Değişim</option>
                  <option value={12}>Ürün Atölyeye Alınacak</option>
                  <option value={46}>Ürün Atölyeye Götürülüyor</option>
                  <option value={23}>Parça Değişimi Gerekiyor</option>
                  <option value={15}>Tesisat Hazır Değil</option>
                  <option value={31}>Müşteri Onayı Bekleniyor</option>
                  <option value={32}>Bölge Onayı Bekleniyor</option>
                  <option value={38}>Emanet Ürün Verildi</option>
                  <option value={92}>Emanet Ürün Talebi</option>
                  <option value={18}>Müşteri Müdehale Ettirmiyor</option>
                  <option value={51}>
                    Müşteri Ziyaret Edildi Evde Bulunamadı
                  </option>
                  {SonlandirData?.[0]?.MaliId && (
                    <option value={52}>Çözüm Merkezi Onayı Bekleniyor</option>
                  )}

                  {SonlandirData?.[0]?.MaliId && (
                    <option value={68}>
                      ÖKC Çözüm Merkezi İptaline Gönder
                    </option>
                  )}
                </Select>
              </FormControl>
            </div>
            <div className={classes.fields}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel
                  id="demo-simple-select-outlined-label"
                  disabled={readonly}
                >
                  {text('islem_Yeri')}
                </InputLabel>
                <Select
                  fullWidth
                  native
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  onChange={handleChangeIslemYeri}
                  label={text('islem_Yeri')}
                  disabled={readonly}
                  value={islemYeri || '1'}
                >
                  <option value={1}>Ev</option>
                  <option value={2}>Atölye</option>
                  <option value={3}>Ticarethane</option>
                  <option value={4}>Yetkili Satıcı</option>
                </Select>
              </FormControl>
            </div>
            {tahsilatGoster && (
              <div className={classes.fields}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel
                    id="demo-simple-select-outlined-label"
                    disabled={readonly}
                  >
                    {'Tahsilat Tipi'}
                  </InputLabel>
                  <Select
                    fullWidth
                    native
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    onChange={handleChangeTahsilatTipi}
                    label={'Tahsilat Tipi'}
                    disabled={readonly}
                    hidden={true}
                    value={tahsilatTipi}
                  >
                    <option value={0}></option>
                    <option value={1}>Nakit</option>
                    <option value={2}>Kredi kartı</option>
                    <option value={3}>Senet</option>
                    <option value={4}>Borç</option>
                    <option value={5}>Diğer</option>
                    <option value={6}>Ödero</option>
                  </Select>
                </FormControl>
              </div>
            )}
            <div className={classes.fields}>
              <TextField
                label={'Proje Kodu'}
                name="ProjeKodu"
                multiline
                fullWidth
                value={ProjeKodu}
                onChange={handleChangeProjeKodu}
                variant="outlined"
                disabled={readonly}
              />
            </div>
            <div className={classes.fields}>
              <TextField
                label={text('Sonuc_Notu')}
                name="SonucNotu"
                multiline
                minRows={4}
                fullWidth
                value={SonucNotu}
                onChange={handleChangeSonucNotu}
                variant="outlined"
                disabled={readonly}
                inputProps={{ maxLength: 2000 }}
              />
              {openLegal ? (
                <Alert
                  variant="warning"
                  open={openLegal}
                  message="Hiçbir zaman müşteri sağlık bilgileri hakkında yazı yazılmamalıdır."
                  onClose={handleCloseopenLegal}
                ></Alert>
              ) : null}
            </div>
            {lojistikPersonelKontrol >= 1 ? (
              <>
                <div className={classes.fields}>
                  <TextField
                    label={'Lojistik Personelleri Ekleme'}
                    name="Lojistik Personelleri Ekleme"
                    multiline
                    fullWidth
                    minRows={3}
                    value={selectedLojisticEmployeesFullNames}
                    variant="outlined"
                    disabled
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button
                            variant="contained"
                            color="secondary"
                            disabled={lojistikPersonelYok}
                            className={classes.submitButton}
                            onClick={handlePersonalEkle}
                            endIcon={<AddIcon />}
                          >
                            {'Ekle'}
                          </Button>
                        </InputAdornment>
                      )
                    }}
                  />
                </div>
                <div className={classes.wrapper}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={lojistikPersonelYok}
                        disabled={lojistikPersonelYok}
                        onChange={handleCheckboxChange}
                      />
                    }
                    label="Lojistik Personeli Yoktur"
                  />
                </div>
              </>
            ) : null}

            <div className={classes.fields}>
              {/* <Typography
                className={classes.title}
                variant="h5"
                color="textSecondary"
                gutterBottom
              >
                <b> */}
              <Button
                variant="outlined"
                color="primary"
                endIcon={
                  SonlandirData[0]?.GARANTI_TIPI_TEXT === 'Garanti Dışı' ? (
                    <ReportIcon style={{ color: '#d32f2f' }} />
                  ) : (
                    <VerifiedUserIcon style={{ color: '#ffffff' }} />
                  )
                }
                style={{
                  textTransform: 'none',
                  backgroundColor:
                    SonlandirData[0]?.GARANTI_TIPI_TEXT === 'Garanti Dışı'
                      ? '#ffebee'
                      : '#FF9800',
                  color: '#424242' // Yazı rengini de okunabilirlik için ayarladık
                }}
              >
                {SonlandirData[0]?.GARANTI_TIPI_TEXT}
              </Button>
              {/* </b>
              </Typography> */}

              {kocailemGoster && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleKocailemOpen}
                  disabled={readonly}
                  endIcon={
                    <VerifiedUserIcon
                      style={{
                        color:
                          parseInt(SonlandirData[0]?.KOCAILEM) === 1
                            ? 'green'
                            : 'red'
                      }}
                    />
                  }
                >
                  KoçAİlem
                </Button>
              )}
            </div>
            <div className={classes.fields}>
              <Typography
                className={classes.title}
                align="right"
                color="textSecondary"
                gutterBottom
              >
                {/* {text("iscilik_Toplamı")} <b>{iscilik_toplam.toFixed(2)} ₺</b> */}
                {text('iscilik_Toplamı')} <b>{iscilik_toplam.toFixed(2)} ₺</b>
              </Typography>
            </div>
            <div className={classes.fields}>
              <Typography
                className={classes.title}
                align="right"
                color="textSecondary"
                gutterBottom
              >
                {text('malzeme_Toplamı')} <b>{malzeme_toplam.toFixed(2)} ₺</b>
              </Typography>
            </div>
            <div className={classes.fields}>
              <Typography
                className={classes.title}
                align="right"
                color="textSecondary"
                gutterBottom
              >
                Yol Toplamı <b>{yol_odeme_toplam.toFixed(2)} ₺</b>
              </Typography>
            </div>
            <div className={classes.fields}>
              <Typography
                className={classes.title}
                align="right"
                color="textSecondary"
                gutterBottom
              >
                {'Toplam'}{' '}
                <b>
                  {(malzeme_toplam + iscilik_toplam + yol_odeme_toplam).toFixed(
                    2
                  )}{' '}
                  ₺
                </b>
              </Typography>
            </div>
            <br />
            {tahsilatGoster && (
              <div className={classes.fields}>
                <TextField
                  name="Tutar"
                  label={'İndirim Sonrası Toplam Tutar'}
                  value={tutar || ''}
                  type="number"
                  onChange={e => handleChangeTutar(e.target.value)}
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">₺</InputAdornment>
                    )
                  }}
                  fullWidth
                  variant="outlined"
                  disabled={readonly}
                />
                <br />
                <Typography
                  className={classes.title}
                  align="right"
                  color="textSecondary"
                  gutterBottom
                >
                  {'Bugüne Kadar Tahsil Edilmiş Tutar'}{' '}
                  <b>{tahsil_edilmis_tutar.toFixed(2)} ₺</b>
                </Typography>
                <br />
                <Typography
                  className={classes.title}
                  align="right"
                  color="textSecondary"
                  gutterBottom
                >
                  {'Tahsil Edilecek Kalan'} <b>{TahsilatTutarKalan} ₺</b>
                </Typography>
                <br />
                <TextField
                  name="TahsilatTutar"
                  label={'Tahsilat Tutarı'}
                  value={TahsilatTutar || ''}
                  type="number"
                  onChange={e => handleChangeTahsilatTutar(e.target.value)}
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">₺</InputAdornment>
                    )
                  }}
                  fullWidth
                  variant="outlined"
                  disabled={readonly}
                />
              </div>
            )}
          </form>
        )}
      </CardContent>
      <Divider />
      <CardActions>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="secondary"
              onClick={openUrunTercihSoru}
              disabled={readonly}
              className={classes.submitButton}
              endIcon={<SendIcon />}
            >
              {text('Merkeze_Gonder')}
            </Button>
          </Grid>
        </Grid>
      </CardActions>
      <Divider />
      <CardActions>
        <Grid container spacing={1}>
          {/* GRUP 3: FİNANSAL (ÖDEME) */}
          <Grid item xs={12}>
            <Typography className={classes.sectionTitle}>
              Ödeme İşlemleri
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleTokenPayCreditSend}
              className={classes.submitButton}
              disabled={!tahsilatGoster}
              endIcon={
                <img src={Odero} alt="oliz" style={{ width: 20, height: 20 }} />
              }
            >
              {'Ödero Ödeme Al'}
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleTokenPayCreditControl}
              className={classes.submitButton}
              disabled={!tahsilatGoster}
              endIcon={
                <img src={Odero} alt="oliz" style={{ width: 20, height: 20 }} />
              }
            >
              Ödero Kontrol
            </Button>
          </Grid>
          <Grid item xs={12}>
            {OlizGoster && (
              <div className={classes.fields}>
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.submitMaterialImage}
                  onClick={() => setOpenQrBarkod(true)}
                  endIcon={
                    <img
                      src={OlizIcon}
                      alt="oliz"
                      style={{ width: 34, height: 34 }}
                    />
                  }
                >
                  Olİz QR Kod Oku
                </Button>
              </div>
            )}
          </Grid>

          {/* GRUP 2: OPERASYONEL İŞLEMLER */}
          <Grid item xs={12}>
            <Typography className={classes.sectionTitle}>
              Saha İşlemleri
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="secondary"
              disabled={readonly}
              onClick={() => setExtraBilgiPopup(true)}
              className={classes.submitButton}
              endIcon={<LibraryAddIcon />}
            >
              Bİlgİ Ekle
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="secondary"
              disabled={readonly}
              onClick={() => setDepositProductPopUp(true)}
              className={classes.submitButton}
              endIcon={<SwapHorizIcon />}
            >
              Emanet Ürün
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleKlimaIcUniteFisOlustur}
              className={classes.submitButton}
              endIcon={<AcUnitIcon />}
            >
              {'Klİma İç Ünite Fiş Oluştur'}
            </Button>
          </Grid>
        </Grid>
      </CardActions>
      <QrBarkodPopup
        onClose={handleQrBarkodClose}
        open={openQrBarkod}
        ScanTime={0}
        CallScreen={0}
      />
      {!readonly && !LoadingControl && <SonlandirOzet />}
      <Dialog
        open={TokenPayPopupOpen}
        onClose={handleClosePayPopupOpen}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {'Seçeceğiniz Telefon Numarasına Ödeme Linki Gönderilecektir!...'}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <div>
            <div className={classes.wrapper}>
              {SonlandirData[0]?.Telefon !== '' ? (
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitButton}
                  onClick={event =>
                    handleSmsGonderSmsAl(
                      event,
                      SonlandirData[0]?.Telefon,
                      1,
                      SonlandirData[0]?.FisNo,
                      SonlandirData[0]?.Musteri,
                      SonlandirData[0]?.TelefonOffline,
                      SonlandirData[0]?.MARKA_KODU
                    )
                  }
                  endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}
                >
                  {'Telefon1 : ' + SonlandirData[0]?.Telefon}
                </Button>
              ) : (
                <div></div>
              )}
            </div>
            <div className={classes.wrapper}>
              {SonlandirData[0]?.Telefon2 !== '' ? (
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitButton}
                  onClick={event =>
                    handleSmsGonderSmsAl(
                      event,
                      SonlandirData[0]?.Telefon2,
                      2,
                      SonlandirData[0]?.FisNo,
                      SonlandirData[0]?.Musteri,
                      SonlandirData[0]?.Telefon2Offline,
                      SonlandirData[0]?.MARKA_KODU
                    )
                  }
                  endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}
                >
                  {'Telefon2 : ' + SonlandirData[0]?.Telefon2}
                </Button>
              ) : (
                <div></div>
              )}
            </div>
            <div className={classes.wrapper}>
              {SonlandirData[0]?.Telefon3 !== '' ? (
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitButton}
                  onClick={event =>
                    handleSmsGonderSmsAl(
                      event,
                      SonlandirData[0]?.Telefon3,
                      3,
                      SonlandirData[0]?.FisNo,
                      SonlandirData[0]?.Musteri,
                      SonlandirData[0]?.Telefon3Offline,
                      SonlandirData[0]?.MARKA_KODU
                    )
                  }
                  endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}
                >
                  {'Telefon3 : ' + SonlandirData[0]?.Telefon3}
                </Button>
              ) : (
                <div></div>
              )}
            </div>
            <div className={classes.wrapper}>
              {SonlandirData[0]?.ArayanTelefon !== '' ? (
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitButton}
                  onClick={event =>
                    handleSmsGonderSmsAl(
                      event,
                      SonlandirData[0]?.ArayanTelefon,
                      4,
                      SonlandirData[0]?.FisNo,
                      SonlandirData[0]?.Musteri,
                      SonlandirData[0]?.ArayanTelefonOffline,
                      SonlandirData[0]?.MARKA_KODU
                    )
                  }
                  endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}
                >
                  {'ArayanTelefon : ' + SonlandirData[0]?.ArayanTelefon}
                </Button>
              ) : (
                <div></div>
              )}
            </div>
            <div className={classes.wrapper}>
              {SonlandirData[0]?.IrtibatTelefon !== '' ? (
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitButton}
                  onClick={event =>
                    handleSmsGonderSmsAl(
                      event,
                      SonlandirData[0]?.IrtibatTelefon,
                      5,
                      SonlandirData[0]?.FisNo,
                      SonlandirData[0]?.Musteri,
                      SonlandirData[0]?.IrtibatTelefonOffline,
                      SonlandirData[0]?.MARKA_KODU
                    )
                  }
                  endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}
                >
                  {'IrtibatTelefon : ' + SonlandirData[0]?.IrtibatTelefon}
                </Button>
              ) : (
                <div></div>
              )}
            </div>
            <div className={classes.wrapper}>
              {SonlandirData[0]?.ALICI_GSM !== '' ? (
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitButton}
                  onClick={event =>
                    handleSmsGonderSmsAl(
                      event,
                      SonlandirData[0]?.ALICI_GSM,
                      5,
                      SonlandirData[0]?.FisNo,
                      SonlandirData[0]?.Musteri,
                      SonlandirData[0]?.ALICI_GSM,
                      SonlandirData[0]?.MARKA_KODU
                    )
                  }
                  endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}
                >
                  {'IrtibatTelefon : ' + SonlandirData[0]?.ALICI_GSM}
                </Button>
              ) : (
                <div></div>
              )}
            </div>
            <br />
            <br />
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Paper className={classes.searchCC} elevation={1}>
            <Input
              className={classes.searchInputCC}
              disableUnderline
              value={FilterPaper}
              onChange={e => ChangeFilter(e.target.value)}
              placeholder="Diğer Telefon(5xxxxxxxxx)"
            />
            <Divider orientation="vertical" flexItem />
            <SendIcon
              onClick={event =>
                handleSmsGonderSmsAl(
                  event,
                  FilterPaper,
                  5,
                  SonlandirData[0]?.FisNo,
                  SonlandirData[0]?.Musteri,
                  FilterPaper,
                  SonlandirData[0]?.MARKA_KODU
                )
              }
              className={classes.searchIconCC}
            />
          </Paper>
        </DialogActions>
        <Divider />
        <DialogActions>
          <Button
            onClick={handleClosePayPopupOpen}
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      {OpenUDGNedenPopUp ? (
        <UDGPopup onClose={handleKartBarkodClose} open={OpenUDGNedenPopUp} />
      ) : (
        ''
      )}
      {MEGOpenPopUp ? (
        <MEGPopup onClose={handleMEGPopUpClose} open={MEGOpenPopUp} />
      ) : (
        ''
      )}
      <Dialog
        open={ExtraBilgiPopup}
        onClose={() => setExtraBilgiPopup(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {'Ekstra Bilgi Girişi'}
        </DialogTitle>
        <DialogContent>
          <div>
            <div className={classes.fields}>
              <TextField
                name="Çevrim Sayısı"
                label={'Çevrim Sayısı'}
                value={CevrimSayisi || '0'}
                type="number"
                onChange={e => handleChangeCevrimSayisi(e.target.value)}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  endAdornment: (
                    <RotateRightIcon position="start"></RotateRightIcon>
                  )
                }}
                fullWidth
                variant="outlined"
                disabled={readonly}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setExtraBilgiPopup(false)} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={urunTercihi}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {'Müşteri Ürün Tercihi'}
        </DialogTitle>
        <DialogContent>
          <div>
            <div className={classes.fields}>
              <Grid container spacing={2}>
                {benchmarkBrandData
                  ?.map(x => ({ MARKA_ADI: x.MARKA_ADI, MARKA_ID: x.MARKA_ID }))
                  ?.map(({ MARKA_ADI, MARKA_ID }, index) => (
                    <>
                      <Grid item xs={6}>
                        <Select
                          fullWidth
                          native
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          onChange={event => handleBrandChange(event, index)}
                          label={text('Durum')}
                          disabled={true}
                          value={benchmarkBrandID}
                        >
                          <option key={index} value={MARKA_ID}>
                            {MARKA_ADI}
                          </option>
                        </Select>
                      </Grid>
                      <Grid item xs={6}>
                        <Select
                          labelId="demo-multiple-checkbox-label"
                          id="demo-multiple-checkbox"
                          multiple
                          value={brandName[index]}
                          onChange={event => {
                            const selectedNames = event.target.value;
                            handleBrandModelChange(index, selectedNames);
                          }}
                          input={<OutlinedInput label="Tag" />}
                          renderValue={selected => selected.join(', ')}
                          MenuProps={MenuProps}
                          fullWidth
                        >
                          {benchmarkBrandData
                            ?.filter(
                              x => x.MARKA_ID === parseInt(index + 1)
                            )?.[0]
                            ?.P?.map(({ MODEL_ADI }, i) => (
                              <MenuItem key={i} value={MODEL_ADI}>
                                <Checkbox
                                  checked={brandName[index]?.includes(
                                    MODEL_ADI
                                  )}
                                />
                                <ListItemText primary={MODEL_ADI} />
                              </MenuItem>
                            ))}
                        </Select>
                      </Grid>
                    </>
                  ))}
              </Grid>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleBrandSave}>
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={urunTercihSoru}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {'Müşteri Ürün Tercihi'}
        </DialogTitle>
        <DialogContent>
          <div>
            <div className={classes.fields}>
              <DialogContentText id="alert-dialog-slide-description">
                NOT: Teknisyenin isteğine bağlı ve gözlemine dayalı bilgi
                girilebilir.
              </DialogContentText>
              <Typography component="span" variant="h6">
                Müşteri evinde farklı marka ürün gözlemlediniz mi ?
              </Typography>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={beforeHandleMerkezeGonder}>
            Evet
          </Button>
          <Button
            color="primary"
            onClick={() => {
              beforeHandleMerkezeGonderHayir();
            }}
          >
            Hayır
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={depositProductPopUp}
        onClose={handleCloseDepositPopupOpen}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {'Emanet Ürün Talebi'}
        </DialogTitle>
        <Divider
          sx={{
            borderColor: '#FF9800', // Divider'ın ana rengi
            '&::before, &::after': {
              borderColor: '#FF9800' // Divider'ın yanlardaki çizgilerinin rengi
            }
          }}
        />
        <DialogContent>
          <div>
            <div className={classes.wrapper}>
              {
                <FormControlLabel
                  disabled={readonly}
                  control={
                    <Checkbox
                      color="primary"
                      checked={EMANET_URUN}
                      onChange={handleConsumerNewProduct}
                      name="EMANET_URUN"
                    />
                  }
                  label="Tüketici Emanet Ürün İstiyor"
                />
              }
            </div>
            <div className={classes.wrapper}>
              {
                <FormControlLabel
                  disabled={readonly}
                  control={
                    <Checkbox
                      color="primary"
                      checked={URUN_KULLANILABILIR}
                      onChange={handleChange}
                      name="URUN_KULLANILABILIR"
                    />
                  }
                  label="Ürün Kullanılabilir Durumda"
                />
              }
            </div>

            <br />
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={handleCloseDepositPopupOpen}
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={personalPrimPopUp}
        onClose={() => {
          setPersonalPrimPopUp(false);
        }}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {'Nakliye Primi'}
        </DialogTitle>
        <Divider
          sx={{
            borderColor: '#FF9800', // Divider'ın ana rengi
            '&::before, &::after': {
              borderColor: '#FF9800' // Divider'ın yanlardaki çizgilerinin rengi
            }
          }}
        />
        <DialogContent>
          <Grid container spacing={2}>
            {!personelEkleme ? (
              <Grid item xs={12}>
                <Typography component="span" variant="h6" spacing={2}>
                  Lütfen ürün taşımada destek olan Lojistik Personeli giriniz.
                  En fazla dört (4) Lojistik Personeli eklenebilir. Eğer destek
                  personel yok ise Lojistik Personel Yoktur'u işaretleyiniz.
                </Typography>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Autocomplete
                  multiple
                  id="multiple-autocomplete"
                  options={personalCalisanlari}
                  getOptionLabel={option => option.AD_SOYAD}
                  onChange={handleLojistikPersonelIdChange}
                  value={selectedLojisticEmployees || []}
                  loading={personalLoading}
                  disabled={personalLoading}
                  noOptionsText={
                    personalLoading
                      ? 'Yükleniyor...'
                      : 'Lojistik personel bulunamadı'
                  }
                  renderInput={params => (
                    <TextField
                      {...params}
                      fullWidth
                      variant="outlined"
                      label="Lojistik Personelleri"
                      placeholder="En fazla 4 personel seçiniz."
                      helperText={
                        personalLoading
                          ? 'Lojistik personeller yükleniyor...'
                          : ''
                      }
                    />
                  )}
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={() => {
              handleLojistikPersonelKaydet();
            }}
            variant="contained"
            color="secondary"
            endIcon={<AddIcon>Kaydet</AddIcon>}
          >
            {'Kaydet'}
          </Button>
          <Button
            onClick={() => {
              setPersonalPrimPopUp(false);
            }}
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            {'Kapat'}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openStackingKitPopUp}
        onClose={() => setOpenStackingKitPopUp(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography
                variant="h6"
                color="text.primary"
                sx={{ fontWeight: 'bold', mb: 2 }}
              >
                Malzemeler
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Box display="flex" justifyContent="flex-end">
                <IconButton
                  color="primary"
                  edge="end"
                  onClick={() => setOpenStackingKitPopUp(false)}
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontStyle: 'italic', mb: 1 }}
              >
                Lütfen bir adet malzeme seçin
              </Typography>
            </Grid>
            {stackingKitData && stackingKitData.length > 0 ? (
              stackingKitData.map((item, index) => (
                <>
                  <Grid item xs={12} key={index}>
                    <Card
                      variant="outlined"
                      onClick={() => handleCardClick(item.MALZEME_KODU)}
                      sx={{
                        cursor: 'pointer',
                        '&:hover': { boxShadow: 3 },
                        minHeight: 250
                      }}
                    >
                      <CardContent
                        style={{
                          backgroundColor:
                            selectedNewRafliKitMetarialCode !== null &&
                            selectedNewRafliKitMetarialCode !==
                              item.MALZEME_KODU
                              ? '#f0f0f0' // sarı
                              : '#f5f6f7',
                          border: '1px solid #ccc', // gri border
                          borderRadius: '8px', // köşeler yuvarlatma
                          boxShadow: '0 2px 6px rgba(0,0,0,0.15)' // gölge
                        }}
                      >
                        <Box display="flex" alignItems="flex-start" gap={1}>
                          <Checkbox
                            checked={
                              selectedNewRafliKitMetarialCode ===
                              item.MALZEME_KODU
                            }
                            onClick={e => e.stopPropagation()} // Kart tıklamasını engelle
                            onChange={() => handleCardClick(item.MALZEME_KODU)} // Checkbox değişimi de aynı fonksiyon
                            disabled={
                              selectedNewRafliKitMetarialCode !== null &&
                              selectedNewRafliKitMetarialCode !==
                                item.MALZEME_KODU
                            } // Diğerlerini disable et
                            size="small"
                          />
                          <Box sx={{ maxHeight: 200, overflow: 'auto', pb: 1 }}>
                            <Typography
                              variant="body2"
                              fontWeight="bold"
                              lineHeight={1.6}
                              sx={{
                                wordBreak: 'break-word',
                                mt: 0.7,
                                lineHeight: 1.6
                              }}
                            >
                              Kod: {item.MALZEME_STOK_NO}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{
                                wordBreak: 'break-word',
                                mt: 0.7,
                                lineHeight: 1.6
                              }}
                            >
                              Açıklama: {item.MALZEME}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{
                                wordBreak: 'break-word',
                                mt: 0.7,
                                lineHeight: 1.6
                              }}
                            >
                              Teknisyen Zimmet Adet:{' '}
                              {item.TEKNISYEN_ZIMMET_ADET}
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </>
              ))
            ) : (
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  color="text.primary"
                  sx={{ fontWeight: 'bold', mb: 2 }}
                >
                  Stokta/Zimmetinizde Stacking Kit Raflı Malzeme
                  Bulunmamaktadır.
                </Typography>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleRafliKitMalzemeIcinFisOlustur()}
            color="primary"
            disabled={!hasZimmet}
          >
            Gönder
          </Button>
          <Button
            onClick={() => setOpenStackingKitPopUp(false)}
            color="primary"
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      {/* Sigorta Satış Fırsatı Popup */}
      <Dialog
        open={insuranceSalesPopup}
        onClose={() => setInsuranceSalesPopup(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: '#FF9800', color: 'white' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <LocalOfferIcon />
            <span>Sigorta Satış Fırsatı!</span>
          </div>
        </DialogTitle>
        <Divider />
        <DialogContent style={{ padding: '24px' }}>
          <Typography
            variant="h6"
            style={{ marginBottom: '16px', fontWeight: 'bold' }}
          >
            🎉 Tebrikler!
          </Typography>
          <Typography variant="body1" style={{ marginBottom: '12px' }}>
            Fiş başarıyla kapatıldı. Bu müşteride{' '}
            <strong>sigorta satış fırsatı</strong> bulunmaktadır.
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginTop: '16px' }}
          >
            Sigorta sekmesine giderek müşteriye uygun sigorta paketlerini
            inceleyebilir ve satış yapabilirsiniz.
          </Typography>
        </DialogContent>
        <Divider />
        <DialogActions style={{ padding: '16px' }}>
          <Button
            onClick={() => setInsuranceSalesPopup(false)}
            variant="outlined"
            color="secondary"
          >
            Daha Sonra
          </Button>
          <Button
            onClick={() => {
              setInsuranceSalesPopup(false);
              history.push(`/WorkOrder/${FisNo}/Sigorta`);
            }}
            variant="contained"
            style={{
              backgroundColor: '#4CAF50',
              color: 'white',
              fontWeight: 'bold'
            }}
            endIcon={<SendIcon />}
          >
            Sigorta Sekmesine Git
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmOpenIcUniteKlima}
        onClose={() => setConfirmOpenIcUniteKlima(false)}
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          <WarningIcon color="primary" />
          Klima İç Ünite Fişi Oluşturma Onayı
        </DialogTitle>
        <Divider
          sx={{
            borderColor: '#FF9800', // Divider'ın ana rengi
            '&::before, &::after': {
              borderColor: '#FF9800' // Divider'ın yanlardaki çizgilerinin rengi
            }
          }}
        />
        <DialogContent>
          <Typography>
            <strong>{SonlandirData[0]?.FisNo}</strong> nolu fiş için Klima İç
            Ünite Fişi oluşturulacak ve eşleştirme otomatik olarak yapılacaktır.
          </Typography>
          <Typography variant="body2" color="error" sx={{ mt: 2 }}>
            Bu işlem geri alınamaz.
          </Typography>
        </DialogContent>
        <Divider
          sx={{
            borderColor: '#FF9800', // Divider'ın ana rengi
            '&::before, &::after': {
              borderColor: '#FF9800' // Divider'ın yanlardaki çizgilerinin rengi
            }
          }}
        />
        <DialogActions>
          <Button
            onClick={() => setConfirmOpenIcUniteKlima(false)}
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Vazgeç
          </Button>
          <Button
            onClick={handleConfirmIcUniteKlima}
            variant="contained"
            color="secondary"
            endIcon={<SendIcon>Send</SendIcon>}
          >
            Oluştur ve Eşleştİr
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}

Sonlandir.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    tasks: state.tasks1
  }),
  { setTask }
)(Sonlandir);
